const messages = {
	en: {
		translations: {
			signup: {
				title: "Sign up",
				toasts: {
					success: "User created successfully! Please login!",
					fail: "Error creating user. Check the reported data.",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Register",
					login: "Already have an account? Log in!",
				},
			},
			platform: {
				title: "Platform status",
				subtitle: "Server resources, database and maintenance. Super admin only.",
				refresh: "Refresh",
				refreshed: "Measurement updated",
				autoOn: "Auto: on",
				autoOff: "Auto: off",
				autoRefreshHint: "Reads the status again every 30 seconds",
				tabs: {
					overview: "Overview",
					files: "Files",
					maintenance: "Maintenance",
					history: "History",
				},
			},
			reports: {
				title: "Reports",
				subtitle: "How your team is doing and what is pending.",
				empty: "No data in this period",
				noQueue: "No department",
				ago: "{{value}} ago",
				tabs: {
					summary: "Summary",
					pending: "Pending",
					team: "Team",
					channels: "Channels & connections",
					tags: "Tags",
					csat: "Satisfaction",
					kanban: "Kanban",
				},
				team: {
					title: "Performance by agent",
					agent: "Agent",
					unassigned: "Unassigned",
					rate: "% resolved",
					sent: "Transfers sent",
					received: "Transfers received",
					returned: "Returned",
					transfersNote: "Transfers are counted since their recording was enabled (doc 0447); earlier ones are not rebuilt.",
				},
				channels: {
					title: "Company connections",
					connection: "Connection",
					channel: "Channel",
					statusLabel: "Status",
					status: {
						CONNECTED: "Connected",
						DISCONNECTED: "Disconnected",
						QRCODE: "Waiting for QR",
						OPENING: "Connecting",
						PAIRING: "Pairing",
						TIMEOUT: "No response",
					},
				},
				tags: {
					title: "Most applied tags in the period",
					applied: "Times applied",
					note: "Counts every time the tag was applied to a chat within the period.",
				},
				kanban: {
					noBoard: "This company has no Kanban board configured.",
					cardsNow: "Cards on the board now",
					enteredPeriod: "Entries in the period",
					slowest: "Slowest stage",
					slowestByStay: "Average stay of {{value}}",
					slowestByAge: "Its cards have been there {{value}} on average",
					funnel: "Cards per stage (now)",
					detail: "Funnel detail",
					stage: "Stage",
					now: "Now",
					avgAge: "Average age",
					entered: "Entries",
					avgStay: "Average stay",
					stuck: "Cards stuck the longest",
					contact: "Contact",
					since: "For",
					note: "Entries and stay per stage are measured since 10/27/2026, when every card move started being recorded; there was no history before. «Now» only counts cards of conversations that are not closed.",
				},
				csat: {
					short: "Rating",
					avgRate: "Average rating",
					answered: "Responses",
					answeredCount: "{{count}} responses",
					satisfied: "Satisfied",
					satisfiedHint: "Rated 4 or 5",
					unsatisfied: "Unsatisfied",
					unsatisfiedHint: "Rated 1 or 2",
					responseRate: "Response rate",
					responseRateHint: "{{answered}} of {{sent}} surveys sent",
					distribution: "Rating distribution",
					byAgent: "Rating by agent",
					enable: "Enable in Options",
					disabledTitle: "The satisfaction survey is turned off",
					disabledText: "When a conversation is closed, the customer can rate the service from 1 to 5. Turn it on in Settings › Options to start measuring your team's satisfaction.",
					disabledNotice: "The survey is turned off: these are earlier ratings. Turn it on in Settings › Options to keep measuring.",
					noAnswersTitle: "No ratings in this period yet",
					noAnswersText: "{{sent}} surveys were sent when closing conversations; the answers will show up here.",
				},
				filters: {
					period: "Period",
					from: "From",
					to: "To",
					all: "All",
					queue: "Department",
					agent: "Agent",
					connection: "Connection",
					presets: {
						today: "Today",
						"7d": "7 days",
						"30d": "30 days",
						custom: "Custom",
					},
				},
				kpi: {
					conversations: "Conversations",
					contacts: "{{count}} distinct contacts",
					resolved: "Resolved",
					unattended: "Unattended",
					unattendedHint: "Nobody took them",
					openNow: "Being attended now",
					pendingNow: "Waiting now",
					avgWait: "Average wait",
					avgWaitHint: "From joining the queue until an agent takes it",
					avgResolution: "Average resolution",
					avgResolutionHint: "From an agent taking it until it is closed",
					avgFirstResponse: "First response",
					avgFirstResponseHint: "From the customer writing until the agent replies",
				},
				charts: {
					overTime: "Conversations in the period",
					byChannel: "By channel",
					byQueue: "By department",
					topAgents: "Agents with most conversations",
				},
				pending: {
					chats: "Waiting chats",
					leads: "Unattended web leads",
					appointments: "Upcoming appointments (48 h)",
					none: "Nothing pending",
					status: {
						pending: "Awaiting confirmation",
						confirmed: "Confirmed",
						rescheduled: "Rescheduled",
						in_progress: "In progress",
					},
				},
			},
			authScreens: {
				heroTitle: "All your chats in one place",
				heroSubtitle: "WhatsApp, Instagram, Messenger and Telegram in one inbox your team understands from day one.",
				mockMsg1: "Can you confirm tomorrow's time?",
				mockMsg2: "Done, I've just paid",
				mockMsg3: "Do you deliver?",
				loginTitle: "Welcome back",
				loginSubtitle: "Sign in to keep serving your customers.",
				loginButton: "Sign in",
				remember: "Remember me",
				noAccount: "Don't have an account?",
				register: "Sign up",
				signupTitle: "Create your account",
				signupSubtitle: "Free for {{days}} days. No card needed.",
				signupButton: "Create free account",
				haveAccount: "Already have an account?",
				signIn: "Sign in",
				company: "Company",
				name: "Your name",
				whatsapp: "WhatsApp",
				password: "Password",
				acceptPrefix: "I accept the",
				terms: "Terms of Use",
				and: "and the",
				privacy: "Privacy Policy",
				showPassword: "Show or hide password",
			},
			passwordRecovery: {
				forgotLink: "Forgot your password?",
				forgotTitle: "Recover your password",
				forgotSubtitle: "Enter the email you sign in with. We'll send you a link to choose a new one.",
				email: "Email",
				send: "Send link",
				sentTitle: "Check your email",
				sentBody: "If that email has an account, a link will arrive in a few minutes. It expires in 30 minutes. Check your spam folder too.",
				backToLogin: "Back to sign in",
				resetTitle: "Choose a new password",
				resetSubtitle: "Saving it will sign you out on every device.",
				newPassword: "New password",
				confirmPassword: "Repeat the password",
				save: "Save password",
				minLength: "At least 8 characters",
				mismatch: "Passwords don't match",
				doneTitle: "Password updated",
				doneBody: "You can now sign in with your new password.",
				goLogin: "Sign in",
				checking: "Checking the link…",
				invalidTitle: "This link doesn't work",
				invalidBody: "It may be incomplete. Request a new one.",
				expiredTitle: "This link has expired",
				expiredBody: "Links last 30 minutes. Request a new one.",
				usedTitle: "This link was already used",
				usedBody: "Each link works only once. Request a new one if you need to change it again.",
				requestNew: "Request a new link",
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Password",
				},
				buttons: {
					submit: "Enter",
					register: "Don't have an account? Register!",
				},
			},
			companies: {
				title: "Company registration",
				form: {
					name: "Company name",
					email: "Email",
					phone: "WhatsApp number",
					plan: "Plans",
					status: "Status",
					campaigns: "Campaigns",
					dueDate: "Due date",
					recurrence: "Recurrence",
					token: "Token",
					submit: "Register",
					success: "Company created successfully!",
				},
			  table: {
					name: "Name",
					email: "Email",
					phone: "Phone",
					plan: "Plans",
					campaigns: "Campaigns",
					status: "Status",
					createdAt: "Created on",
					dueDate: "Due date",
				},
				messages: {
					loadError: "Could not load the records list",
					saveSuccess: "Operation completed successfully!",
					saveError:
						"Could not complete the operation. Check for duplicate company name or incomplete fields.",
					deleteSuccess: "Operation completed successfully!",
					deleteError: "Could not complete the operation",
					deleteTitle: "Delete record",
					deleteMessage: "Do you really want to delete this record?",
					registerRefreshPage:
						"Company registered. Refresh the page to see changes.",
				},
				formTitle: {
					edit: "Edit company",
					registerNew: "Register new company",
				},
				sections: {
					basicInfo: "Basic information",
					configuration: "Settings",
				},
				loadingPlans: "Loading plans...",
				timezone: {
					label: "Time zone",
					loading: "Loading time zones...",
					loadingValue: "{{tz}} (loading...)",
					fallbackCurrent: "{{tz}} (current)",
					hint: "Time zone for displaying dates and times in messages and tickets.",
					ariaLabel: "Time zone",
				},
				grid: {
					emptyTitle: "No companies registered",
					emptySubtitle: "Start by registering your first company",
				},
				tooltips: {
					editCompany: "Edit company",
				},
				buttons: {
					clear: "Clear",
					delete: "Delete",
					save: "Save",
					addDueDate: "+ Due date",
					user: "User",
					registerCompany: "Register company",
					saving: "Saving...",
				},
				register: {
					formTitle: "Register new company",
					companyInfoSection: "Company information",
					successTitle: "Company registered successfully!",
					loadPlansError: "Could not load available plans",
					closingForm_one: "Closing the form in {{count}} second...",
					closingForm_other: "Closing the form in {{count}} seconds...",
					redirecting_one: "Redirecting to the Companies tab in {{count}} second...",
					redirecting_other:
						"Redirecting to the Companies tab in {{count}} seconds...",
					validation: {
						nameMin: "Name too short",
						nameMax: "Name too long",
						nameRequired: "Name is required",
						passwordMin: "Password must be at least 8 characters",
						passwordMax: "Password too long",
						passwordRequired: "Password is required",
						emailInvalid: "Invalid email",
						emailRequired: "Email is required",
						phoneMin: "Phone number too short",
						phoneRequired: "WhatsApp number is required",
						planRequired: "Plan is required",
					},
					buttons: {
						cancel: "Cancel",
						back: "Back",
						registering: "Registering...",
						registered: "Registered!",
					},
				},
				values: {
					yes: "Yes",
					no: "No",
					enabled: "Enabled",
					disabled: "Disabled",
					monthly: "Monthly",
					bimonthly: "Bimonthly",
					quarterly: "Quarterly",
					semiannual: "Semiannual",
					annual: "Annual",
				},
			},
			auth: {
				toasts: {
					success: "Login successfully!",
				},
			},
			dashboard: {
				charts: {
					perDay: {
						title: "Tickets today: ",
					},
				},
			},
			connections: {
				title: "Connections",
				addDialog: {
					button: "Add connection",
					title: "Add connection",
					subtitle: "Choose where your team will answer.",
					cancel: "Cancel",
					notConfigured: "Not configured: enable it in Settings › Integrations.",
					channels: {
						baileys: { title: "WhatsApp (QR code)", description: "Scan a QR code with your phone. Ready in a minute." },
						waba: { title: "WhatsApp official API", description: "Meta's official API, for high volume and templates." },
						facebook: { title: "Facebook Messenger", description: "Receive the messages of your Facebook page." },
						instagram: { title: "Instagram", description: "Reply to the direct messages of your professional account." },
						telegram: { title: "Telegram", description: "Link your Telegram account with a QR code." },
						email: { title: "Email", description: "Read and reply to the emails in your Gmail inbox." },
						webform: { title: "Web form", description: "A landing page that turns visits into leads." },
					},
				},
				toasts: {
					deleted: "WhatsApp connection deleted sucessfully!",
					disconnected: "WhatsApp disconnected — {{name}}",
					connected: "WhatsApp connected — {{name}}",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? It cannot be reverted.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Are you sure? You'll need to read QR Code again.",
				},
				buttons: {
					add: "Add WhatsApp",
					disconnect: "Disconnect",
					tryAgain: "Try Again",
					qrcode: "QR CODE",
					newQr: "New QR CODE",
					connecting: "Connectiing",
				},
				toolTips: {
					disconnected: {
						title: "Failed to start WhatsApp session",
						content:
							"Make sure your cell phone is connected to the internet and try again, or request a new QR Code",
					},
					qrcode: {
						title: "Waiting for QR Code read",
						content:
							"Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
					},
					connected: {
						title: "Connection established",
					},
					timeout: {
						title: "Connection with cell phone has been lost",
						content:
							"Make sure your cell phone is connected to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
					},
				},
				table: {
					name: "Name",
					token: "Token",
					tokenEmpty: "No token (edit the connection to set one)",
					status: "Status",
					lastUpdate: "Last Update",
					default: "Default",
					actions: "Actions",
					session: "Session",
				},
			},
			securityAudit: {
				title: "Security",
				subtitle: "Security log of your company: sign-ins, permission and password changes, tokens and alerts. Kept for 180 days.",
				subtitleSuper: "Security log of every company and the platform, with alerts. Kept for 180 days.",
				empty: "No events for these filters.",
				loadMore: "Load more",
				platform: "Platform",
				filters: {
					action: "Event",
					result: "Result",
					from: "From",
					to: "To",
					all: "All",
				},
				columns: {
					date: "Date",
					action: "Event",
					result: "Result",
					actor: "Who",
					target: "On what",
					ip: "IP",
					company: "Company",
				},
				results: {
					ok: "Success",
					fallo: "Failed",
					bloqueado: "Blocked",
				},
				actions: {
					login: "Sign-in",
					logout: "Sign-out",
					refresh: "Session renewal",
					password_change: "Password change",
					password_reset_request: "Password recovery request",
					user_create: "User created",
					user_delete: "User deleted",
					role_change: "Role change",
					permissions_change: "Permission change",
					token_regenerate: "API token generated",
					token_reveal: "API token viewed",
					platform_credentials_change: "Platform credentials changed",
					token_auth: "API token use",
					rate_limit: "Rate limit",
					export: "Export",
					audit_mode: "View as another user",
					company_create: "Company created",
					company_delete: "Company deleted",
					security_alert: "Security ALERT",
				},
			},
			whatsappModal: {
				tokenShownOnce: "API token for this connection: {{token}} — Copy it now: for security it will not be shown again.",
				tokenKeepPlaceholder: "Leave empty to keep the current one",
				tokenSaved: "Saved (ends in {{preview}}). Type a new one only if you want to change it.",
				tokenReveal: "Show token",
				tokenCurrent: "Current token (for your integrations)",
				tokenCopy: "Copy",
				tokenCopied: "Token copied",
				title: {
					add: "Add WhatsApp",
					edit: "Edit WhatsApp",
				},
				form: {
					name: "Name",
					default: "Default",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "WhatsApp saved successfully.",
			},
			qrCode: {
				message: "Read QrCode to start the session",
			},
			contacts: {
				title: "Contacts",
				toasts: {
					deleted: "Contact deleted sucessfully!",
					deletedAll: "All contacts deleted successfully!",
				},
				searchPlaceholder: "Search ...",
        confirmationModal: {
					deleteTitle: "Delete",
					importTitle: "Import contacts",
					deleteAllTitle: "Delete all",
					deleteMessage:
						"Are you sure you want to delete this contact? All related tickets will be lost.",
					deleteAllMessage:
						"Are you sure you want to delete all contacts? All related tickets will be lost.",
					importMessage: "Do you want to import all contacts from the phone?",
					importAgendaMessage:
						"There are {count} contacts in your address book. Import them?",
					exportTitle: "Export contacts",
					exportMessage:
						"Are you sure you want to export the selected contacts?",
					exportAllMessage: "Are you sure you want to export all contacts?",
					titleExportAll: "Export all contacts",
					titleExportOne: "Export 1 contact",
					titleExportMany: "Export {{count}} contacts",
					titleDeleteOne: "Delete 1 contact",
					titleDeleteMany: "Delete {{count}} contacts",
					exportConfirmAll:
						"Are you sure you want to export all contacts?",
					exportConfirmMany:
						"Are you sure you want to export {{count}} contact(s)?",
					deleteSelectedMany:
						"Are you sure you want to delete {{count}} contact(s)? All related tickets will be lost.",
				},
				tooltips: {
					importAgendaDisabled:
						"This feature is temporarily disabled. Baileys 6.7.21 does not support fetching contacts directly. It will be re-enabled when a compatible Baileys version is available.",
				},
				buttons: {
					import: "Import address book",
					importSheet: "Import spreadsheet",
					add: "Add",
					export: "Export",
					delete: "Delete",
					downloadTemplate: "Download template",
				},
				table: {
					profile: "Profile",
					name: "Name",
					whatsapp: "WhatsApp",
					email: "Email",
					lastInteraction: "Last interaction",
					status: "Status",
					actions: "Actions",
				},
				messages: {
					selectToExport: "Select at least one contact to export",
					processingExport: "Processing {count} contacts... This may take a few seconds.",
					exportSuccess: "Contacts exported successfully",
					exportError: "Could not export contacts. Please try again.",
					checkingAgenda: "Checking phone address book...",
					agendaEmpty: "No contacts were found in the phone address book.",
					importInvalidResponse: "Invalid server response",
					importErrorGeneric: "Could not import contacts",
					templateDownloadSuccess: "Template downloaded successfully",
					templateDownloadError: "Could not download the template",
				},
				pagination: {
					rowsPerPage: "Rows per page:",
					displayedRows: "{{from}}–{{to}} of {{count}}",
				},
				badge: {
					contact: "contact",
					contacts: "contacts",
				},
			},
			promptModal: {
				form: {
					name: "Name",
					prompt: "Prompt",
					voice: "Voice",
					max_tokens: "Max tokens in the response",
					temperature: "Temperature",
					apikey: "API key",
					max_messages: "Max messages in history",
					voiceKey: "Voice API key",
					voiceRegion: "Voice region",
				},
				success: "Prompt saved successfully!",
				title: {
					add: "Add prompt",
					edit: "Edit prompt",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
					cancelUpper: "CANCEL",
					expand: "EXPAND",
					saveChanges: "Save changes",
				},
				sections: {
					provider: "AI provider setup",
					api: "API configuration",
					basic: "Basic information",
					advanced: "Advanced settings",
					media: "Media files",
					workMode: "Work mode",
				},
				providerInfo: {
					title: "AI provider setup",
					body1:
						"Choose the AI provider this prompt will use. Each provider offers different models and capabilities for your needs.",
					body2:
						"Available providers: official OpenAI, Google Gemini (AI Studio), Anthropic Claude, DeepSeek, Kimi, and OpenRouter. Each option needs that provider’s API key (OpenRouter uses sk-or-v1-…).",
				},
				mustValidateBeforeSave:
					"You must validate the API key and provider before saving. Use the “Test connection” button.",
				mustValidateBeforeSaveWithStored:
					"If you changed provider or pasted a new key, run “Test connection”. To edit only prompt text/options, leave the key empty and keep the same provider.",
				validation: {
					nameRequired: "Name is required",
					apiKeyRequired: "API key is required",
					promptRequired: "Prompt is required",
					maxTokensRequired: "Max tokens is required",
					temperatureRequired: "Temperature is required",
					maxMessagesRequired: "Max messages is required",
				},
				fields: {
					aiProvider: "AI provider",
					promptName: "Prompt name",
					promptNameHelper: "E.g. Support bot, sales assistant…",
					promptNamePlaceholder: "E.g. Support bot",
					mainPrompt: "Main prompt",
					mainPromptHelper: "Define how the AI should behave. Be specific and clear.",
					mainPromptPlaceholder:
						"You are a technical support assistant. Reply in a professional, helpful way…",
					charCount: "Character count: {{count}}",
					temperature: "Temperature",
					temperatureHelper: "0.0 = deterministic, 2.0 = very creative",
					maxTokens: "Max tokens",
					maxTokensHelper: "Token limit for the response",
					maxMessages: "Max messages",
					maxMessagesHelper: "Messages kept in context",
					queueOptional: "Departments (optional)",
					noQueue: "No department",
					workModeLabel: "Work mode",
					workModeLayers: "Context layers",
					workModePdfs: "PDF documents",
					workModeHintLayers: "Uses context layers triggered by keywords",
					workModeHintPdfs: "Upload PDFs for the AI to learn from",
				},
				apiTest: {
					validating: "Validating…",
					validated: "✅ Validated",
					validatedHelper: "✅ API key validated",
					storedKeyMaskPlaceholder:
						"Paste here only when changing the key (when editing, the saved key is shown).",
					storedKeyHelper:
						"When editing this prompt your API key is loaded from the server. Leave as-is to keep it or replace it to update. Use Test connection to validate.",
					testConnection: "Test connection",
					enterApiKeyFirst: "Please enter an API key first",
					selectProviderFirst: "Please select a provider first",
					keyTooShortToast:
						"The API key looks too short. Check that it is correct.",
					keyTooShort: "API key too short",
					connectionSuccess: "Connection successful",
					validationFailed: "Validation failed",
					validateError: "Error validating API",
					unknownError: "Unknown error",
				},
				media: {
					savePromptFirst: "Save the prompt first",
					savePromptFirstToast: "Save the prompt first",
					unknownFileType: "Error: unrecognized file type",
					noFilesSelected: "No files selected",
					unexpectedError: "Unexpected error: {{message}}",
					fileDeleted: "File deleted successfully",
					deleteFileError: "Error deleting file: {{message}}",
					maxSixFiles: "Maximum 6 files per prompt",
					urlAdded: "External URL added successfully",
					urlAddError: "Error adding URL: {{message}}",
					addUrl: "Add URL",
					uploadFile: "Upload file",
					hintFiles:
						"📎 You can add up to 6 media files (images, video, audio, documents)",
					hintLimits:
						"📏 Limits: images/audio 10 MB, video/documents 15 MB",
					hintSyntax:
						"💡 Use [MEDIA: filename.ext] in your prompt to reference files",
					filesCount: "{{current}}/6 files added",
					uploadSuccessCount: "{{count}} file(s) added successfully",
					maxSixWithCounts:
						"Maximum 6 files per prompt. You already have {{current}} and are adding {{adding}}. You can only add {{remaining}} more.",
					maxSixNoMore:
						"Maximum 6 files per prompt. You already have {{count}} files. No more can be added.",
					someRejected: "Some files could not be added: {{list}}",
					fileTooBig: "{{name}}: exceeds {{maxMb}} MB",
					uploadPartial:
						"{{uploaded}} file(s) added, {{failed}} failed: {{names}}",
					uploadFailedDetail: "Error uploading files: {{details}}",
					uploadNone:
						"Could not upload any file. Check the console for details.",
				},
				urlDialog: {
					title: "Add external URL",
					urlLabel: "File URL",
					urlPlaceholder: "https://example.com/file.jpg",
					captionLabel: "Description (optional)",
					captionPlaceholder: "File description",
					hintPublic: "💡 Make sure the URL is publicly accessible",
					add: "Add",
					close: "Close",
				},
				expanded: {
					confirmClose: "Save changes before closing?",
					title: "Expanded editor — main prompt",
					unsavedChip: "Unsaved changes",
					intro:
						"Edit your prompt with more space. Media references [MEDIA: filename.ext] will be highlighted in the preview.",
					editorPlaceholder: "Write your prompt here…",
					charCount: "Character count: {{count}}",
					previewTitle: "Preview (highlighted):",
					toastSaved: "Prompt updated successfully",
				},
			},
			prompts: {
				title: "Prompts",
				table: {
					name: "Name",
					queue: "Sector/Queue",
					max_tokens: "Max response tokens",
					actions: "Actions",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteTitleNamed: "Delete prompt «{{name}}»?",
					deleteMessage: "Are you sure? This cannot be undone!",
				},
				buttons: {
					add: "Add prompt",
				},
				listPage: {
					title: "AI prompts",
					addButton: "Add prompt",
					providersTitle: "Available AI providers",
					providersIntro:
						"Choose the AI provider that best fits your needs. We support official providers: OpenAI, Gemini, Grok, Deepseek®, and OpenRouter.",
					providersApiKey:
						"Each provider offers different models and capabilities. Make sure you have a valid API key for the selected provider.",
					tablePromptName: "Prompt name",
					tableProvider: "AI provider",
					tableMaxTokens: "Max tokens",
					tableTemperature: "Temperature",
					tableMaxMessages: "Max messages",
					tableActions: "Actions",
					tokensChip: "{{count}} tokens",
					tooltipEdit: "Edit prompt",
					tooltipDelete: "Delete prompt",
				},
			},
			contactModal: {
				title: {
					add: "Add contact",
					edit: "Edit contact",
				},
				form: {
					mainInfo: "Contact details",
					extraInfo: "Additional information",
					name: "Name",
					number: "Whatsapp number",
					email: "Email",
					extraName: "Field name",
					extraValue: "Value",
				},
				buttons: {
					addExtraInfo: "Add information",
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Contact saved successfully.",
			},
			queueModal: {
				title: {
					add: "Add department",
					edit: "Edit department",
				},
				tabs: {
					queueData: "Department data",
					serviceHours: "Service hours",
				},
				automation: {
					title: "Process automation",
					intro:
						"You can automate conversations with custom prompts, FlowBuilder workflows, external integrations, or a menu chatbot: the contact taps buttons in the chat instead of free text. Only one of the four can be active at a time; all are optional.",
				},
				form: {
					name: "Name",
					departmentName: "Department name",
					color: "Color",
					greetingMessage: "Greeting message",
					enableGreeting: "Enable greeting",
					greetingEnabledOn: "Enabled — the welcome message will be sent.",
					greetingEnabledOff: "Disabled — no greeting is shown or sent.",
					greetingRequired: "If greeting is enabled, you must enter a message.",
					outOfHoursMessage: "Out of hours message",
					integrationId: "Integration",
					noIntegration: "No integration",
				},
				confirmationModal: {
					deleteTitle: "Delete",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				schedules: {
					title: "Scheduled messages",
					confirmationModal: {
						deleteTitle: "Delete this schedule?",
						deleteMessage: "This cannot be undone.",
					},
					table: {
						contact: "Contact",
						body: "Message",
						sendAt: "Scheduled date",
						sentAt: "Sent at",
						status: "Status",
						actions: "Actions",
					},
					buttons: {
						add: "New schedule",
					},
					toasts: {
						deleted: "Schedule deleted successfully.",
					},
					saveSuccess: "Business hours saved.",
					saveButton: "Save hours",
				},
			},
			userModal: {
			  tabs: {
			    user: "User",
			    extra: "Additional"
			  },
        title: {
          add: "Add user",
          edit: "Edit user",
        },
        form: {
          emailSignature: "Email signature",
          emailSignatureHint: "Added at the foot of your emails when «Sign» is on. If empty, your name is used.",
          name: "Name",
          email: "Email",
          password: "Password",
          profile: "Profile",
          superAdmin: "Super administrator",
          queuesFromTeam: "Departments come from their team. The individual ones are kept in case team mode is turned off.",
          whatsappHint: "Connection used for tickets this user creates manually. Empty = the company default.",
                    superAdminHint: "This role is granted at installation and cannot be changed here.",
          roleUnavailable: "Role not available in this company",
          language: "Panel language",
        },
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "User saved successfully.",
			},
			scheduleModal: {
				title: { add: "New schedule", edit: "Edit schedule" },
				form: {
					body: "Message",
					contact: "Contact",
					sendAt: "Scheduled date & time",
					sentAt: "Sent at",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
					cancelMeeting: "Cancel meeting",
					exit: "Exit",
				},
				selectConnectionPlaceholder: "Select a connection",
				bodyCharCounter: "{{current}}/500 characters",
				success: "Schedule saved successfully.",
				toasts: {
					deleted: "Attachment removed successfully.",
					meetingCancelled: "Meeting cancelled successfully.",
					updated: "✅ Schedule updated successfully",
					created: "✅ Schedule created successfully",
					noDataSave: "❌ Error: nothing to save",
				},
				confirmationModal: {
					deleteTitle: "Remove attachment",
					deleteMessage: "Remove this attachment?",
				},
				cancelMeetingTitle: "Cancel meeting",
				cancelMeetingMessage:
					"Are you sure you want to cancel this meeting? A cancellation message will be sent to the contact.",
				confirmScheduleTitle: "Confirm scheduled message?",
				confirmScheduleDate: "Date & time:",
				confirmScheduleContact: "Contact:",
				confirmScheduleWhatsapp: "Connection:",
				confirmScheduleMessage: "Message:",
				confirmScheduleQuestion:
					"Do you confirm scheduling with the details shown?",
				validationErrorTitle: "❌ Validation error",
				understood: "OK",
				validationGeneric: "Could not validate the schedule",
				contactNotFound: "Contact not found",
				whatsappNotFound: "Connection not found",
				dialogStatusErro: "Send error",
				dialogStatusPrefix: "Message",
				autocompleteNoContacts: "No contacts found",
				searchContactLabel: "Type to search contacts",
				searchContactPlaceholder: "Click to see available contacts",
				attachFile: "Attach file",
				validation: {
					required: "Required",
					invalidDateTime: "❌ Invalid date/time",
					pastDateTime:
						"❌ Cannot schedule in the past. Current time: {{now}}",
					minTenMinutes:
						"❌ Minimum lead time is 10 minutes. Earliest allowed: {{min}}",
					maxOneYear: "❌ Cannot schedule more than one year ahead",
					febMaxDays: "❌ February cannot have more than 29 days",
					feb29Leap: "❌ Feb 29 only exists in leap years",
					month30: "❌ Month {{month}} cannot have more than 30 days",
					bodyShort: "Message too short",
					messageMax: "❌ Message cannot exceed 500 characters",
					messageMinChars: "❌ Message must be at least 3 characters",
					messageMinValid:
						"❌ Message needs at least 2 valid characters",
					allFieldsRequired:
						"❌ All fields are required: contact, connection, message and date/time",
				},
				connectionFallback: "Connection {{id}}",
			},
			tagModal: {
				title: { add: "New tag", edit: "Edit tag" },
				form: {
					name: "Name",
					color: "Color",
					namePlaceholder: "E.g. Support, Lead, Follow-up…",
					pickColorTitle: "Pick color",
					kanbanLabel: "Use in Kanban",
					kanbanHint:
						"Tags with Kanban enabled appear as columns on the board",
				},
				validation: { nameMin: "Name too short", required: "Required" },
				buttons: { okAdd: "Add", okEdit: "Save", cancel: "Cancel" },
				success: "Tag saved successfully.",
			},
			schedulePage: {
				moduleTitle: "Agenda module",
				scheduledTotal: "{{count}} schedules",
				title: "Schedules ({{count}})",
				notAvailable: "N/A",
				viewTable: "Table view",
				viewCalendar: "Calendar view",
				newButton: "New schedule",
				table: {
					date: "Date",
					time: "Time",
					contact: "Contact",
					connection: "Connection",
					message: "Message",
					status: "Status",
					actions: "Actions",
				},
				status: {
					error: "Error",
					cancelled: "Cancelled",
					sent: "Sent",
					overdue: "Overdue",
					pending: "Pending",
				},
				cancelMeetingTitle: "Cancel meeting?",
				cancelScheduleTitle: "Cancel schedule?",
				cancelMeetingMessage:
					"Cancel this meeting? All related reminders will be removed.",
				cancelScheduleMessage:
					"Cancel this schedule? A cancellation message will be sent to the contact.",
				toastMeetingCancelled: "Meeting cancelled",
				toastScheduleCancelled: "Schedule cancelled",
				deleteTitleAlreadyCancelled: "Already cancelled",
				deleteTitleCancel: "Cancel schedule",
				calendar: {
					date: "Date",
					time: "Time",
					event: "Event",
					allDay: "All day",
					week: "Week",
					work_week: "Schedules",
					day: "Day",
					month: "Month",
					previous: "Previous",
					next: "Next",
					yesterday: "Yesterday",
					tomorrow: "Tomorrow",
					today: "Today",
					agenda: "Agenda",
					noEventsInRange: "No schedules in this range.",
					showMore: "+{{total}} more",
				},
			},
			appointmentsModule: {
				page: {
					moduleTitle: "Agenda module",
					newAppointment: "New appointment",
					tabs: {
						dashboard: "Dashboard",
						calendar: "Calendar",
						history: "History",
						webLeads: "Web requests",
						settings: "Settings",
					},
					accessDeniedTitle: "You don’t have access to the Agenda module",
					accessDeniedP1:
						"You must be linked as a professional/instructor in Agenda > Settings > Team, or be an administrator.",
					accessDeniedP2:
						"Flow: Register the user first → then link them as Professional under Team.",
					goHome: "Go to home",
					checkingAccess: "Checking access…",
				},
				status: {
					all: "All",
					pending: "Pending",
					confirmed: "Confirmed",
					rescheduled: "Rescheduled",
					in_progress: "In progress",
					completed: "Completed",
					no_show: "No-show",
					cancelled: "Cancelled",
				},
				webLeads: {
					loading: "Loading requests…",
					empty: "No requests have arrived from the website yet",
					emptyHint:
						"As soon as someone submits the form on the page, it will show up here without reloading.",
					countLine: "{{count}} requests · {{pending}} unreviewed",
					autoRefreshHint: "Refreshes on its own every 10 seconds.",
					reload: "Reload",
					filterAll: "All",
					statusNueva: "New",
					statusVista: "Seen",
					statusDescartada: "Discarded",
					justNow: "A few seconds ago",
					minutesAgo: "{{count}} min ago",
					colReceived: "Received",
					colName: "Name",
					colPhone: "WhatsApp",
					colPreferred: "Preferred date",
					colService: "Service",
					colSource: "Source",
					colStatus: "Status",
					colActions: "Actions",
					phoneConfirmedWhatsapp: "Confirmed: real WhatsApp check verified this number exists",
					phoneUnchecked: "Format accepted, but not yet checked against real WhatsApp",
					phoneInvalidFormat:
						"Could not be parsed as a valid WhatsApp number — check how the visitor typed it",
					phoneNoWhatsapp:
						"Real WhatsApp check confirmed this number does not exist — the lead was not converted into a ticket",
					tableAria: "Requests received from the website",
					markSeen: "Mark as seen",
					discard: "Discard",
					seeContact: "View contact profile",
					seePayload: "View received data",
					payloadTitle: "Data received from the form",
					payloadHint: "Original body exactly as it arrived, unmodified.",
					close: "Close",
					deleteLead: "Delete (permanent, admin only)",
					deleteConfirmTitle: "Delete this request forever?",
					deleteConfirmMessage:
						"You're about to permanently delete {{name}}'s request — it won't stay as \"Discarded\", it's gone completely. Only use this for test data, never for a real lead.",
					deleteSuccess: "Request deleted.",
				},
				calendar: {
					date: "Date",
					time: "Time",
					event: "Event",
					today: "Today",
					previous: "Previous",
					next: "Next",
					month: "Month",
					week: "Week",
					day: "Day",
					agenda: "Agenda",
					noEventsInRange: "No appointments in this range.",
					noName: "No name",
					serviceFallback: "Service",
				},
				dashboard: {
					wd0: "Mon",
					wd1: "Tue",
					wd2: "Wed",
					wd3: "Thu",
					wd4: "Fri",
					wd5: "Sat",
					wd6: "Sun",
					kpiWeek: "Sessions this week",
					kpiPending: "Awaiting confirmation",
					kpiToday: "Sessions today",
					kpiRate: "Attendance rate (30 days)",
					chartTitle: "Sessions per day — {{month}}",
					todayTitle: "Today’s sessions",
					todayEmpty: "No sessions scheduled for today",
					todayLine: "{{time}}: {{contact}} — {{service}}",
					professionalPrefix: "Professional:",
					upcomingTitle: "Upcoming sessions",
					upcomingEmpty: "No sessions scheduled in the next 30 days",
					chartConfirmed: "Confirmed",
					chartPending: "Pending",
					chartCancelled: "Cancelled",
				},
				historial: {
					loading: "Loading history…",
					empty: "No appointments match the filters",
					emptyHint:
						"Adjust dates or status in the header to see more results",
					countOrder: "{{count}} appointments · Sort: {{order}}",
					orderAsc: "soonest first",
					orderDesc: "most recent first",
					changeOrder: "Change sort order",
					edit: "Edit",
					editReschedule: "Edit / Reschedule",
					editAria: "Edit appointment",
					tableAria: "Appointment history",
					colDate: "Date",
					colTime: "Time",
					colContact: "Contact",
					colService: "Service",
					colProfessional: "Professional",
					colStatus: "Status",
					colActions: "Actions",
					rowsPerPage: "Rows per page:",
					rowsPerPageShort: "Rows:",
					displayedRows: "{{from}}-{{to}} of {{count}}",
				},
				config: {
					firstTimeTitle: "First time setting up Agenda?",
					firstTimeSubtitle:
						"Set up profile, services, team and business hours in a few steps.",
					firstTimeCta: "Start here",
					activeProfileTitle: "Active profile: {{name}}",
					activeProfileSubtitle:
						"Change any part of your initial setup.",
					cardPerfilTitle: "Business type / profile",
					cardPerfilDesc:
						"Define whether you are Beauty, Sales, Health, Education or Technical. Affects wording and Kanban columns.",
					cardServiciosTitle: "Services / programs",
					cardServiciosDesc:
						"Catalog of services, subjects or programs with duration and price.",
					cardEquipoTitle: "Instructor team",
					cardEquipoDesc:
						"Professionals who serve customers. Link each one to a user so they can access Agenda and confirm appointments.",
					cardHorariosTitle: "Business hours",
					cardHorariosDesc: "Days, hours and slot duration per day.",
					cardSecuenciasTitle: "Automatic AI Agent sequences",
					cardSecuenciasDesc:
						"When and how the AI Agent captures data and triggers flows (appointment request). Tone is configured in AI Prompts.",
					equipoIntro:
						"Link each professional to a user (from Users) so they can open Agenda and confirm appointments.",
					equipoConfigureBtn:
						"Configure team (names, roles and specialties)",
					loadingProfessionals: "Loading professionals…",
					tableProfessional: "Professional",
					tableRole: "Role / specialty",
					tableLinkUser: "Link to user",
					noneUser: "— None —",
					noProfessionals:
						"No professionals yet. Use the button above to add the team in initial setup.",
					secuenciasIntro:
						"Choose which AI Agent (Prompt) is used to capture appointment requests in chat. Tone and personality are set on that agent.",
					loading: "Loading…",
					kanbanHint:
						"If you changed business type, recreate Kanban columns for the current profile.",
					kanbanRecreate: "Recreate Kanban columns",
					kanbanProcessing: "Processing…",
					edit: "Edit",
					editSectionAria: "Edit {{section}}",
					businessDialogTitle: "Business details",
					businessDialogDesc:
						"Edit the name, profile, time zone and currency. Your services, team, hours and appointments are left untouched.",
					businessDialogName: "Business name",
					businessDialogProfile: "Business profile",
					businessDialogProfileHelper:
						"If you change the profile, use “Recreate Kanban columns” to update the board.",
					businessDialogTimezone: "Time zone",
					businessDialogCurrency: "Currency",
					businessDialogCancel: "Cancel",
					businessDialogSave: "Save changes",
					businessDialogSaving: "Saving…",
					businessDialogSaved: "Business details updated.",
					toastLinkOk:
						"Link updated. The instructor can access Agenda with their user.",
					toastKanbanOk: "Kanban columns recreated for the profile.",
					errorProfileFirst:
						"Configure the profile in initial setup first.",
				},
				appointmentModal: {
					titleNew: "New appointment",
					notifyContact: "Notify the patient now",
					notifyContactOn: "The confirmation template will be sent over WhatsApp on save.",
					notifyContactOff: "The appointment is created confirmed, but with no immediate notice.",
					titleEdit: "Appointment {{code}}",
					contactFallback: "Contact #{{id}}",
					client: "Client:",
					service: "Service:",
					professional: "Professional:",
					date: "Date:",
					statusLabel: "Status",
					viewProfile360: "View 360 profile",
					rescheduleHint:
						"Enter the new date, service and professional to reschedule. A notification will be sent to the contact.",
					newDateTime: "New date & time *",
					duration: "Duration (minutes)",
					notes: "Notes",
					introNew:
						"Register a new appointment manually. Type to search and pick from the filtered list.",
					contactLabel: "Contact *",
					contactPlaceholder: "Type name or number to search…",
					contactHelper: "Required. Search by name or phone.",
					noOptionsShort: "Type at least 2 characters to search",
					noOptionsEmpty: "No results",
					connectionLabel: "Connection *",
					connectionPlaceholder:
						"Select the WhatsApp line (connection) for this appointment",
					connectionHelper:
						"Required. The connection under which the appointment is stored (same logic as scheduled reminders).",
					connectionNamed: "Connection {{id}}",
					dash: "—",
					serviceField: "Service",
					serviceSearchPh: "Search service…",
					serviceHelper: "Optional. Service catalog.",
					noServices: "No services configured",
					professionalField: "Professional",
					professionalSearchPh: "Search professional…",
					professionalHelper: "Optional. Instructor team.",
					noProfessionalsConfigured: "No professionals configured",
					datetimeLabel: "Date & time *",
					datetimeHelper: "Required. Appointment time.",
					durationHelper: "Default 60 minutes.",
					notesPlaceholder: "Additional notes…",
					cancel: "Cancel",
					saveReschedule: "SAVE & RESCHEDULE",
					saveStatus: "Save status",
					create: "Create appointment",
					toastContactDateRequired: "Contact and date are required",
					toastWhatsappRequired: "Select the WhatsApp connection for the appointment",
					toastStatusUpdated: "Status updated",
					toastCreated: "Appointment created",
					toastRescheduleDateRequired:
						"New date is required to reschedule",
					toastRescheduled:
						"Appointment rescheduled. Notification sent to the contact.",
				},
			},
			toDoList: {
				title: "Operator notes",
				searchPlaceholder: "Search tasks…",
				stats: {
					total: "Total",
					pending: "Pending",
					completed: "Done",
					urgent: "Urgent",
				},
				form: {
					newTask: "New task",
					editTask: "Edit task",
					descriptionLabel: "Task description",
					descriptionPlaceholder: "E.g. Review server settings…",
					priority: "Priority",
					category: "Category",
					add: "Add task",
					save: "Save changes",
					cancel: "Cancel",
				},
				priority: { low: "Low", medium: "Medium", high: "High" },
				categories: {
					general: "General",
					urgent: "Urgent",
					followup: "Follow-up",
					meeting: "Meeting",
					system: "System",
					customer: "Customer",
				},
				filters: { title: "Filters", all: "All", allStatus: "All", status: "Status" },
				statusLabel: { pending: "Pending", completed: "Completed" },
				empty: {
					none: "No tasks yet",
					noneHint: "Create your first task with the form above",
					filtered: "No tasks match the filters",
					filteredHint: "Adjust filters to see more tasks",
				},
				tooltips: {
					markPending: "Mark as pending",
					markDone: "Mark as completed",
					edit: "Edit task",
					delete: "Delete task",
				},
			},
			helps: {
				title: "Help center",
				form: {
					title: "Title",
					videoCode: "Video URL (YouTube)",
					description: "Description",
				},
				table: { title: "Title", description: "Description", video: "Video" },
				buttons: { clear: "Clear", delete: "Delete", save: "Save", saving: "Saving..." },
				formTitle: {
					edit: "Edit help video",
					create: "Create new help video",
				},
				sectionVideo: "Help video information",
				placeholders: {
					video: "https://youtu.be/6FdRJTw46qI or https://yourdomain.com/video.mp4",
					thumbnail: "https://yourdomain.com/thumbnails/video.jpg",
				},
				helpers: {
					youtubeDetected: "✅ YouTube video detected",
					externalDetected: "✅ External video detected",
					pasteHint:
						"Paste a YouTube URL or an external video URL (e.g. https://yourdomain.com/video.mp4)",
				},
				thumbnail: {
					label: "Thumbnail URL (optional)",
					hint: "Optional custom thumbnail image URL. If empty, YouTube thumbnail or a placeholder is used.",
				},
				grid: {
					emptyTitle: "No help videos registered",
					emptySubtitle: "Create your first help video to get started",
				},
				tooltips: {
					editRow: "Edit help video",
				},
				validation: {
					invalidVideoInput:
						"Invalid video URL. Enter a YouTube URL or a valid external URL (e.g. https://yourdomain.com/video.mp4)",
					processFailed: "Could not process the video URL",
					urlInvalid: "Invalid URL. It must start with http:// or https://",
					urlExtensionHint:
						"The URL has no video file extension. Ensure the server returns the correct Content-Type.",
				},
				toast: {
					youtubeDetected: "YouTube video detected: {{code}}",
					externalDetected: "External video detected and saved",
				},
				messages: {
					loadError: "Could not load help items",
					saveSuccess: "Saved successfully.",
					saveError:
						"Could not save. Check for duplicate name or incomplete fields.",
					deleteSuccess: "Deleted successfully.",
					deleteError: "Could not delete",
					deleteTitle: "Delete item",
					deleteMessage: "Delete this help item?",
					videoUnavailable: "Video not available",
					videoLoadError: "Could not load video",
					videoLoadHint:
						"The video may be unavailable or blocked on this domain.",
					videoCorsHint:
						"Ensure the server allows public access (CORS) and the URL is correct.",
					youtubeError: "Could not load YouTube video",
					videoUrlError:
						"Could not load video. Check the URL and format.",
					videoNotSupported: "Your browser does not support video.",
				},
			},
			tags: {
				title: "Tags",
				confirmationModal: {
					deleteTitle: "Delete this tag?",
					deleteMessage: "This cannot be undone.",
					deleteAllMessage: "Delete all tags?",
					deleteAllTitle: "Delete all",
				},
				table: {
					name: "Name",
					tagName: "Tag name",
					color: "Color",
					tickets: "Tagged tickets",
					taggedTickets: "Tagged tickets",
					kanban: "Kanban",
					origin: "Origin",
					actions: "Actions",
				},
				kanbanActive: "ACTIVE",
				kanbanInactive: "OFF",
				originProfile: "By profile",
				originManual: "Manual",
				readOnly: "Read-only",
				profileTagTitle: "Kanban column from Calendar setup. Read-only.",
				manualTagTitle: "Manually created tag",
				readOnlyHint:
					"Profile columns cannot be edited here. Change profile in Calendar > Settings.",
				columnRenameTitle: "Rename column",
				columnRenamePrompt: "New name for this board column:",
				columnRenameHelper: "Only the visible text changes; the board keeps working the same.",
				columnNameRequired: "The column name cannot be empty.",
				columnSaved: "Column updated. It will be kept when the Kanban is recreated.",
				columnsReordered: "Column order saved.",
				reorderNeedsNoFilter: "Clear the search to reorder columns.",
				tooltips: {
					editTag: "Edit tag",
					deleteTag: "Delete tag",
					renameColumn: "Rename board column",
					hideColumn: "Hide board column",
					showColumn: "Show board column",
				},
				buttons: { add: "New tag", deleteAll: "Delete all", cancel: "Cancel", save: "Save" },
				toasts: {
					deletedAll: "All tags deleted.",
					deleted: "Tag deleted.",
				},
			},
			files: {
				title: "File lists",
				adminTitle: "File manager",
				searchPlaceholder: "Search file lists…",
				newList: "New file list",
				listCount: "{{count}} lists",
				table: {
					name: "List name",
					description: "Description",
					fileCount: "Files",
					createdAt: "Created",
					actions: "Actions",
				},
				noDescription: "No description",
				filesInList: "{{count}} files",
				tooltips: { editList: "Edit list", deleteList: "Delete list" },
				contacts: "Contacts",
				actions: "Action",
				toasts: {
					deleted: "List deleted.",
					deletedAll: "All lists deleted.",
				},
				buttons: { add: "Add", deleteAll: "Delete all" },
				confirmationModal: {
					deleteTitle: "Delete",
					deleteAllTitle: "Delete all",
					deleteMessage: "Delete this list?",
					deleteAllMessage: "Delete all lists?",
				},
			},
			fileModal: {
				title: { add: "New file list", edit: "Edit file list" },
				buttons: {
					okAdd: "Save",
					okEdit: "Update",
					cancel: "Cancel",
					fileOptions: "Add file",
				},
				form: {
					name: "List name",
					message: "List details",
					fileOptions: "Files",
					extraName: "Caption sent with file",
					extraValue: "Option value",
				},
				dragDrop: {
					sectionTitle: "Files",
					main: "Drag and drop files here",
					sub: "or click to select files",
					formats:
						"Supported: PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, PNG, MP4, MP3",
				},
				table: {
					thumbnail: "Thumb",
					name: "Name",
					format: "Format",
					size: "Size",
					type: "Type",
					actions: "Actions",
				},
				validation: { nameMin: "Name too short", required: "Required" },
				fileSize: { bytes: "Bytes", kb: "KB", mb: "MB", gb: "GB" },
				tooltips: { removeFile: "Remove file" },
				success: "File list saved.",
			},
			financial: {
				title: "Billing",
				pageTitle: "Billing and subscriptions",
				tabs: {
					subscriptions: "Subscriptions",
					invoices: "Invoices",
					management: "Management",
				},
				table: {
					id: "ID",
					details: "Details",
					value: "Amount",
					dueDate: "Due date",
					status: "Status",
					action: "Action",
				},
				status: {
					paid: "Paid",
					overdue: "Overdue",
					open: "Open",
				},
				buttons: {
					pay: "PAY",
					paid: "PAID",
				},
				messages: {
					noInvoices: "No invoices to display",
					paymentSuccess: "Payment processed successfully",
					paymentError: "Could not process payment",
				},
				subscription: {
					planDetails: "Plan details",
					usersLabel: "Users",
					billingMonthly: "Billing: Monthly",
					title: "Subscription",
					checkoutSuccess: "Subscription completed. Waiting for payment confirmation",
					currentPlanLabel: "Current plan",
					noPlanAssigned: "No plan assigned",
					availablePlans: "Available plans",
					availablePlansHint:
						"Choose a plan to subscribe. You can pay with PayPal or Stripe.",
					perMonth: "/mo",
					users_one: "{{count}} user",
					users_other: "{{count}} users",
					connections_one: "{{count}} WhatsApp connection",
					connections_other: "{{count}} WhatsApp connections",
					queues_one: "{{count}} queue",
					queues_other: "{{count}} queues",
					featureCampaigns: "Campaigns",
					featureSchedules: "Scheduling",
					featureOpenAi: "Artificial intelligence",
					subscribe: "Subscribe",
					processing: "Processing…",
					noPlansTitle: "No plans available",
					noPlansHint: "Contact your administrator for more information",
				},
			},
			kanban: {
				open: "Open",
				tagNotFound: "Tag not found.",
				cannotMapStatus: "Cannot map column to appointment status.",
				theContact: "the contact",
				confirmMoveConfirmed: "You are about to confirm {{name}}'s appointment and a WhatsApp message will be sent.",
				confirmMoveCompleted: "You are about to mark {{name}}'s appointment as completed and the follow-up message will be sent.",
				confirmMoveCancelled: "You are about to cancel {{name}}'s appointment and a WhatsApp message will be sent.",
				confirmMoveTitle: "Confirm move",
				columnsReordered: "Column order saved.",
				dragColumnHint: "Drag the header to reorder this column",
				confirmMoveIrreversible: "The message cannot be undone. Continue?",
				moveNotAllowed: "That move is not allowed for the current appointment status.",
				unassignedOwner: "Unassigned",
				attendedByAI: "Handled by {{name}}",
				appointmentUpdated: "Appointment updated.",
				ticketMoved: "Ticket moved.",
				moveError: "Could not move card.",
				configureAgendaHint:
					"Set up Calendar in Settings to use profile Kanban.",
			},
			chat: {
				noTicketMessage: "Select a ticket to start chatting.",
				buttons: {
					new: "New",
				},
			},
			ticketsManager: {
				buttons: {
					newTicket: "New",
				},
				confirmation: {
					title: "⚠️ Confirm ticket closure",
					subtitle: "This will permanently close ALL open tickets",
					warning: "This action cannot be undone",
					whichTicketsQuestion: "Which tickets do you want to close?",
					noTicketsForOption:
						"No tickets to close for the selected option",
					warningEmojiAria: "Warning",
					optionAttendingOpen: "IN PROGRESS (Open)",
					optionPending: "PENDING",
					optionBoth: "BOTH (IN PROGRESS + PENDING)",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Queues",
			},
			tickets: {
				accessDenied: "You don't have access to this ticket",
				toasts: {
					deleted: "The ticket you were on has been deleted.",
				},
				notification: {
					message: "Message from",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Resolved" },
					search: { title: "Search" },
				},
				search: {
					placeholder: "Search tickets and messages.",
					searchMessagesTooltip:
						"Also search message content (slower)",
				},
				buttons: {
					showAll: "All",
				},
				preview: {
					image: "🖼️ Image",
					video: "🎥 Video",
					audio: "🎵 Audio",
					document: "📄 Document",
					sticker: "🔖 Sticker",
					location: "📍 Location",
					contact: "👤 Contact",
					deleted: "🚫 Message deleted",
					none: "No messages",
				},
				simple: {
					title: "Chats",
					scopeMine: "Mine",
					scopeMineDesc: "Chats assigned to you",
					scopeAll: "All",
					scopeAllDesc: "The whole company",
					chipOpen: "Attending",
					chipPending: "Waiting",
					chipGroups: "Groups",
					chipAi: "AI agents",
					chipClosed: "Resolved",
					searchPlaceholder: "Search name, number or message",
					filters: "Filters",
					clearFilters: "Clear",
					searchInMessages: "Also search inside messages",
					queues: "Departments",
					tags: "Tags",
					moreOptions: "More options",
					resolveBulk: "Resolve chats in bulk",
					newChat: "New chat",
					chatActions: "Chat actions",
					viewConversation: "View conversation",
					otherConversation: "This contact has another open conversation on another channel",
					yesterday: "Yesterday",
					backToList: "Back to list",
					more: "More actions",
					scheduleMessage: "Schedule message",
					moreMenu: "More",
					you: "You",
					noQueue: "No department",
					unassigned: "Unassigned",
					profile: "Profile",
					language: "Language",
					volume: "Alert volume",
					colorTheme: "Color theme",
					darkMode: "Dark mode",
					online: "Online",
					search: "Search",
					searchPage: "Search page",
					noResults: "No results",
					paletteHint: "↑ ↓ navigate · Enter open · Esc close",
				},
				managerTabs: {
					tooltips: {
						newTicket: "Create new ticket",
						resolveTickets: "Resolve tickets",
						showOpen: "Show open tickets",
						showClosed: "Show closed tickets",
						filterByQueues: "Filter by queues",
						filterByTags: "Filter by tags",
						activeFilters: "View active filters",
					},
					emptyQueues: "No queues available",
					emptyTags: "No tags available",
					tabs: {
						groups: "GROUPS",
						aiAgents: "AI AGENTS",
					},
				},
				filterPanel: {
					title: "Filters",
					show: "Show",
					hide: "Hide",
					departments: "Queues",
					tags: "Tags",
					departmentsWithCount: "Queues ({{count}})",
					tagsWithCount: "Tags ({{count}})",
					clearFilters: "Clear filters",
					emptyState:
						"No active filters. Select queues or tags above.",
				},
				welcome: {
					title: "Welcome to your chat workspace",
					subtitle:
						"You can open a new chat or wait until one is assigned to you",
				},
				aria: {
					resizeTicketsPanel: "Resize tickets panel",
				},
				mobile: {
					bottomNav: {
						chat: "Chat",
						tickets: "Tickets",
					},
				},
				searchResults: {
					searchAria: "Search",
					searching: "Searching...",
					resultsFor: 'Results for "{{term}}"',
					noResults: "No results found",
					emptySection: "No results in this section.",
					total: "{{count}} total",
					sections: {
						open: "IN PROGRESS",
						pending: "PENDING",
						closed: "CLOSED",
					},
				},
			},
			transferTicketModal: {
				sinDestino: "Choose a department or a person: the ticket cannot be left without a destination.",
				title: "Transfer Ticket",
				fieldLabel: "Type to search for users",
				noOptions: "No user found with this name",
				buttons: {
					ok: "Transfer",
					cancel: "Cancel",
				},
			},
			ticketsList: {
				noQueue: "No department",
				spyConversation: "Spy conversation",
				pendingHeader: "Queue",
				assignedHeader: "Working on",
				allHeader: "All",
				noTicketsTitle: "Nothing here!",
				noTicketsMessage: "No tickets found with this status or search term.",
				buttons: {
					accept: "Accept",
				},
			},
			emailEditor: {
				bold: "Bold",
				italic: "Italic",
				underline: "Underline",
				bullets: "Bulleted list",
				numbers: "Numbered list",
				quote: "Quote",
				link: "Link",
				clear: "Clear formatting",
				linkPrompt: "Link address (https://… or mailto:…)",
			},
			newTicketModal: {
				title: "Create Ticket",
				email: {
					to: "To",
					toPlaceholder: "email@example.com",
					subject: "Subject",
					body: "Message",
					send: "Send email",
					addCopies: "Add CC / BCC",
					cc: "CC",
					bcc: "BCC",
					copiesHint: "Separate several addresses with commas.",
					attach: "Attach files",
					sign: "Include my signature",
					hint: "A new thread starts with this subject. The customer reply lands in this same ticket.",
				},
				fieldLabel: "Type to search for a contact",
				add: "Add",
				buttons: {
					ok: "Save",
					cancel: "Cancel",
				},
			},
			myTeam: {
			  title: "My team",
			  activity: "Team activity",
			  online: "Online",
			  offline: "Offline",
			  subtitle: "Your company, the teams you belong to and who supervises them.",
			  supervisor: "Supervisor",
			  noSupervisor: "This team has no supervisor assigned yet.",
			  departments: "Departments served",
			  noDepartments: "This team has no departments assigned.",
			  members: "Members",
			  youSupervise: "You supervise this team",
			  you: "you",
			  inheritsRole: "Inherits their role",
			  noTeams: "You do not belong to any team. You work with your role's scope.",
			  table: {
			    name: "Name",
			    role: "Role in this team",
			    state: "Status",
			    handling: "Handling",
			    closedToday: "Closed today"
			  }
			},
			userTeams: {
			  label: "Team they belong to",
			  labelOne: "Team they supervise",
isSupervisor: "Already supervises this team.",
			  			  willSupervise: "Will supervise {{team}}.",
supervisedByLabel: "supervised by",
			  noSupervisor: "no supervisor",
			  required: "They must belong to a team.",
			  noneFree: "No free teams: all have a supervisor",
			  empty: "No teams created yet"
			},
			roleMatrix: {
			  modules: {
			    agenda: "Calendar",
			    announcements: "Announcements",
			    api: "API",
			    campaigns: "Campaigns",
			    chats: "Internal chat",
			    connections: "Connections",
			    contacts: "Contacts",
			    files: "File lists",
			    financial: "Billing",
			    flowbuilder: "FlowBuilder",
			    groups: "WhatsApp groups",
			    kanban: "Kanban",
			    prompts: "AI agents",
			    queues: "Departments",
			    quickmessages: "Quick replies",
			    reports: "Reports",
			    roles: "Roles and permissions",
			    schedules: "Scheduled messages",
			    settings: "Settings",
			    tags: "Tags",
			    tickets: "Tickets",
			    "user-groups": "Subgroups",
			    users: "Users"
			  },
			  page: {
			    title: "Roles and permissions",
			    subtitle: "Define what each role can do in each module (view / create / edit / delete…).",
			    newRole: "New role",
			    colCode: "Code",
			    colName: "Name",
			    colScope: "Scope",
			    colPerms: "Permissions",
			    colUsers: "Users",
			    colActions: "Actions",
			    systemTooltip: "System role: editing it creates a copy for your company",
			    duplicate: "Duplicate",
			    duplicated: "Role duplicated",
			    deleted: "Role deleted",
			    confirmDeleteTitle: "Delete role {{name}}?",
			    confirmDeleteBody: "Users with this role must be reassigned before deleting it.",
			    duplicateTitle: "Duplicate role: {{name}}",
			    duplicateHint: "A new editable role will be created with the {{total}} permissions of the original. The source role is not modified.",
			    copyCodeSuffix: "_COPY",
			    copyNameSuffix: " (copy)"
			  },
			  scopes: {
			    empresa: "Company",
			    equipo: "Team",
			    personal: "Personal",
			    plataforma: "Platform"
			  },
			  modal: {
			    new: "New role",
			    edit: "Edit role: {{name}}",
			    subtitle: "Check what this role can do in each module.",
			    superadminNotice: "The SUPERADMIN role cannot be modified: it is the only one that could leave the system with nobody able to restore permissions.",
			    copyNotice: "This role is shared by all companies. On save, a version owned by your company will be created with your changes; the others are not affected.",
code: "Code",
			    name: "Name",
			    			    frozenTooltip: "You cannot modify a permission you do not have",
			    saved: "Matrix updated",
			    sessionsNotice: "Affects {{total}} user(s); they will see it on their next reload",
			    selectedCount: "{{total}} permission(s) selected",
			    save: "Save",
			    cancel: "Cancel"
			  },
			  bulk: {
			    all: "Select all",
			    allClear: "Clear all",
			    column: "Select whole column",
			    columnClear: "Clear whole column",
			    row: "Select whole row",
			    rowClear: "Clear whole row"
			  },
			  columns: {
			    module: "Module"
			  },
			  actions: {
			    ver: "View",
			    crear: "Create",
			    editar: "Edit",
			    eliminar: "Delete",
			    aprobar: "Approve",
			    procesar: "Process",
			    administrar: "Manage"
			  }
			},
			mainDrawer: {
				groups: {
					whatsapp: "Chats",
					dashboard: "Reports",
					gruposWA: "WA groups",
					mensajes: "Messaging",
					configuracion: "Settings",
					administracion: "Administration",
					flowbuilder: "FlowBuilder",
					utilidades: "Utilities",
				},
				listItems: {
					dashboard: "Dashboard",
					metrics: "Reports",
					platform: "Platform status",
					connections: "Connections",
					wabaTemplates: "Meta Templates",
					tickets: "Tickets",
					quickMessages: "Quick replies",
					kanban: "Kanban",
					todolist: "Notes",
					contacts: "Contacts",
					groupsWA: "WA group list",
					queues: "Queues",
					tags: "Tags",
					administration: "Administration",
					users: "Users",
					userRoles: "User roles",
					rolesPermissions: "Roles and permissions",
					securityAudit: "Security",
					userGroups: "Subgroups",
					myTeam: "My team",
					settings: "Settings",
					helps: "Help",
					messagesAPI: "API",
					schedules: "Calendar",
					campaigns: "Campaigns",
					campaignsDispatch: "Message broadcasts",
					metaCampaigns: "Meta Campaigns",
					scheduledMessages: "Individual",
					contactLists: "Contact lists",
					campaignShippingReports: "Shipping reports",
					broadcastTemplates: "Broadcast Templates",
					annoucements: "Announcements",
					chats: "Internal chat",
					localChat: "Local chat",
					financeiro: "Billing",
					subscription: "Subscription",
					files: "File list",
					prompts: "AI agents",
					queueIntegration: "Integrations",
					flowbuilders: "Flow list",
					flowcampaigns: "Flow campaigns",
					dashboardWhatsApp: "WhatsApp",
					vpsPerformance: "VPS performance",
					groupCampaigns: "Group campaigns",
				},
				appBar: {
					notRegister: "No notifications",
					user: {
						profile: "Profile",
						logout: "Logout",
						label: "User:",
					},
					tooltips: {
						openDrawer: "Open menu",
						closeDrawer: "Close menu",
						navigationMenu: "Navigation menu",
						openNavigationMenu: "Open navigation menu",
						internalChat: "Internal chat",
						help: "Help",
						announcements: "Announcements",
						whatsappNotifications: "Messages from your channels",
						settings: "Settings",
						updateVersion: "Update version",
						logout: "Sign out",
					},
					settingsMenu: {
						lightMode: "Light mode",
						darkMode: "Dark mode",
						logs: "Logs",
					},
					versionLong: "VERSION {{version}}",
					versionShort: "V{{version}}",
				},
			},
			notifications: {
				noTickets: "No notifications.",
				whatsappDisconnected: {
					title: "No WhatsApp connections",
					body:
						"No active connections. Set up or reconnect your WhatsApp connections to continue.",
					reconnect: "RECONNECT NOW",
					close: "Close",
				},
			},
			whatsappConnectionsMenu: {
				loadingConnections: "Loading connections…",
				tooltipNoConnections:
					"No WhatsApp connections — click for details",
				tooltipSomeConnected:
					"At least one connection is active — click to view list",
				tooltipNoneActive:
					"No active connection — click to view list",
				ariaLabel: "WhatsApp connections status",
				menuTitle: "WhatsApp connections",
				loading: "Loading…",
				noneConfigured: "No connections configured",
				connectionFallback: "Connection #{{id}}",
				manage: "Manage connections…",
				status: {
					connected: "Connected",
					opening: "Connecting…",
					disconnected: "Disconnected",
				},
			},
			quickMessages: {
				title: "Quick replies",
				searchPlaceholder: "Search...",
				searchFieldPlaceholder: "Search quick replies...",
				noAttachment: "No attachment",
				noFile: "No attachment",
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This cannot be undone. Continue?",
				},
				buttons: {
					add: "Add",
					addReply: "Add reply",
					attach: "Attach file",
					cancel: "Cancel",
					edit: "Edit",
				},
				toasts: {
					success: "Shortcut saved!",
					deleted: "Shortcut deleted!",
				},
				dialog: {
					title: "Quick message",
					shortcode: "Shortcut",
					message: "Reply",
					save: "Save",
					cancel: "Cancel",
					geral: "Allow editing",
					add: "Add",
					edit: "Edit",
					visao: "Allow view",
				},
				table: {
					shortcode: "Shortcut",
					message: "Message",
					actions: "Actions",
					mediaName: "File name",
					status: "Status",
					shortcodeHeader: "SHORTCUT",
					mediaNameHeader: "FILE NAME",
					statusHeader: "STATUS",
					actionsHeader: "ACTIONS",
				},
				tooltips: {
					openAttachment: "Click to open file",
					edit: "Edit quick reply",
					delete: "Delete quick reply",
				},
			},
			messagesAPI: {
				reference: {
					copy: "Copy",
					copied: "Copied to clipboard",
					request: "Request example",
					response: "Response example",
					curl: "cURL example",
					paramName: "Parameter",
					paramValue: "Value / description",
					textBody: "Message text",
					mediaFile: "File (image, video, document or audio)",
					optionalText: "Accompanying text (optional)",
					groupId: "Group ID (@g.us is appended automatically)",
				},
				auth: {
					title: "Authentication",
				},
				instance: {
					comingSoon: "Coming soon",
					body: "Connection management via API (Baileys only): check status, get the QR code and force reconnect. The Bearer token identifies the connection.",
					statusTitle: "Connection status",
					statusDesc: "Returns the current state: connected/disconnected, linked number, battery and provider.",
					qrTitle: "QR code",
					qrDesc: "Returns the QR string (qrcode) and also the ready-to-use qrImage (data:image/png;base64) to display with <img> directly. If empty, force generation with POST /reconnect and query again until it appears.",
					qrNote: "Typical flow: POST /reconnect to generate a fresh QR → poll GET /qr every few seconds until scanned → GET /status confirms CONNECTED.",
					qrViewTitle: "Hosted QR page",
					qrViewDesc: "Ready-to-use HTML page that shows the QR live, auto-refreshes it and detects the connection. Open it in a browser or embed it in an iframe — ideal for clients without a frontend (Excel, scripts). The token goes in the URL.",
					qrViewNote: "Zero-code onboarding: the end user scans and the page detects CONNECTED on its own. The token travels in the URL (use short-lived links).",
					reconnectTitle: "Reconnect",
					reconnectDesc: "Restarts the session and generates a fresh QR if needed (does not delete credentials). Useful when the connection drops.",
					rebootTitle: "Reboot",
					rebootDesc: "Logs out of WhatsApp Web and forces a fresh scan. Clears state but keeps the connection configuration.",
					rebootNote: "Destructive action: disconnects the current number. You'll need to scan a new QR to reconnect.",
					resetTitle: "Full reset",
					resetDesc: "Clean slate: logs out, deletes stored credentials and generates a brand-new QR.",
					resetNote: "Destructive and irreversible: deletes the connection credentials. Use only to link a different number or fix a corrupted state.",
					webhookTitle: "Register webhook",
					webhookDesc: "Registers a URL that will receive connection events (for now: connection status changes). Events are POSTed as { event, instanceId, timestamp, data }.",
					webhookUrlParam: "https URL that will receive the events (POST)",
					webhookEnableParam: "true/false to enable or disable (optional; defaults to true when url is present)",
					webhookNote: "Connection status events are sent (event: connection.update); when status is qrcode, the payload includes qrcode + qrImage (you receive the QR via push, no polling). Inbound/outbound message events will arrive in a later version.",
				},
				nav: {
					auth: "Authentication",
					instance: "Instance / Connection",
					messages: "Messaging",
					groups: "Groups",
					external: "CRM / External",
					account: "Account / Provisioning",
				},
				account: {
					body: "ACCOUNT-level endpoints to provision connections. They use the account API Key (not the per-connection token). Creation respects your plan's connection limit.",
					keyTitle: "Account API Key",
					keyLoading: "Loading…",
					keyWarning: "Treat it like a password. Regenerating it invalidates the previous one.",
					regenerate: "Regenerate API Key",
					regenerated: "API Key regenerated",
					keyHidden: "Saved (ends in {{preview}}). For security it is not shown again: regenerate it if you need it.",
					copyNow: "Copy the key now: for security it will not be shown again.",
					regenerateError: "Could not regenerate the API Key",
					createTitle: "Create connection",
					createDesc: "Creates a new connection (instance) in the account and returns its per-connection token to operate it. Respects the plan's connection quota.",
					createNameParam: "Connection name (required)",
					createProviderParam: "baileys (default and only accepted value)",
					createNote: "The returned token is the per-connection token: use it on /api/v1/instance/* and /api/messages/*. If you exceed the plan limit, a quota error is returned.",
					listTitle: "List connections",
					listDesc: "Lists all account connections with their status and per-connection token.",
				},
				title: "Public API",
				documentation: {
					title: "Message sending documentation",
					methods: "Sending methods",
					instructions: "Instructions",
					importantNotes: "Important notes",
					textMessages: "Text messages",
					mediaMessages: "Media messages",
					endpoint: "Endpoint",
					method: "Method",
					headers: "Headers",
					body: "Body",
					formData: "FormData",
					testSend: "Send test",
					send: "Send",
				},
				instructions: {
					tokenRequired:
						"Before sending messages, register the token linked to the connection that will send them. Go to Connections, edit the connection, and paste the token in the appropriate field.",
					numberFormat:
						"The destination number must not include masks or special characters. It must contain:",
					countryCode: "Country code",
					areaCode: "Area code",
					number: "Number",
				},
				importantInfo: {
					title: "Important information",
					tokenLabel: "Token required",
					tokenBody:
						"You must register a token linked to the connection that will send the messages",
					formatLabel: "Number format",
					formatBody: "Country code + area code + number (no special characters)",
					exampleLabel: "Example",
					exampleBody:
						"51959858768 (Peru: 51, area: 959, number: 858768)",
				},
				chips: {
					endpoint: "ENDPOINT",
					method: "METHOD",
					headers: "HEADERS",
					upTo100mb: "UP TO 100MB",
				},
				common: {
					apiInfoTitle: "API information",
					testSendTitle: "Send test",
					bodyJson: "Body (JSON):",
					formData: "FormData:",
				},
				section1: {
					title: "1. Text messages",
					intro: "Send plain text messages through the WhatsApp Business API.",
					bodySnippet: `{ "number": "51959858768", "body": "Your message" }`,
				},
				section2: {
					title: "2. Media messages",
					intro:
						"Send media files (images, videos, documents, audio) through the WhatsApp Business API.",
					maxCapacity: "Maximum capacity:",
					maxCapacityBody: "Files up to 100 MB",
					formDataNumber: "number:",
					formDataNumberEx: "51959858768",
					formDataMedias: "medias:",
					formDataMediasEx: "file",
					formDataBody: "body:",
					formDataBodyEx: "optional caption text",
					fileTypesTitle: "Supported file types:",
					images: "Images:",
					imagesEx: "JPG, PNG, GIF (up to 5MB)",
					videos: "Videos:",
					videosEx: "MP4, AVI, MOV (up to 16MB)",
					documents: "Documents:",
					documentsEx: "PDF, DOC, XLS, PPT (up to 100MB)",
					audio: "Audio:",
					audioEx: "MP3, WAV, OGG (up to 16MB)",
				},
				section3: {
					title: "3. WhatsApp group messages",
					intro: "Send text messages to WhatsApp groups through the API.",
					bodySnippet: `{ "number": "12036312345678901234", "body": "Your message" }`,
					groupNote: "Note:",
					groupNoteBody:
						"The system will automatically append the @g.us suffix to the group ID",
				},
				section4: {
					title: "4. Group media messages",
					intro:
						"Send media files to WhatsApp groups through the API.",
					formDataNumberLi: "Group ID (e.g. 12036312345678901234)",
					formDataMediasLi: "media file",
				},
				forms: {
					tokenRegistered: "Registered token",
					tokenRegisteredReq: "Registered token *",
					tokenPlaceholder: "Enter your token here",
					number: "Number",
					numberReq: "Number *",
					message: "Message",
					messageReq: "Message *",
					messageOptional: "Message (optional)",
					messageOptionalPlaceholder:
						"Optional caption to send with the file...",
					messagePlaceholder: "Type your message here",
					numberPlaceholder: "51980795094",
					fileName: "File name",
					sendMessage: "SEND MESSAGE",
					sendMedia: "Send media",
					selectFile: "Select file",
					clickUploadHint: "Click to select a media file",
					fileSize: "Size:",
					groupId: "Group ID *",
					groupIdHelper:
						"Group ID without @g.us (e.g. 12036312345678901234)",
					groupIdHelperShort: "Group ID without @g.us",
					sendToGroup: "Send to group",
					sendMediaToGroup: "Send media to group",
				},
				fileSize: {
					bytes: "Bytes",
					kb: "KB",
					mb: "MB",
					gb: "GB",
				},
				apiInfo: {
					textMessageInfo:
						"Below is the information required to send text messages:",
					mediaMessageInfo:
						"Below is the information required to send media messages:",
					authorization:
						"Authorization (Bearer token) and Content-Type (application/json)",
					multipartForm:
						"Authorization (Bearer token) and Content-Type (multipart/form-data)",
					exampleBody: '{ "number": "51959858768", "body": "Your message" }',
					exampleNumber: "51959858768",
					exampleFile: "file",
				},
				textMessage: {
					number: "Number",
					body: "Message",
					token: "Registered token",
				},
				mediaMessage: {
					number: "Number",
					body: "File name",
					media: "File",
					token: "Registered token",
				},
				section5: {
					d: {
						byNumber: "Look up a ticket's status and data by the contact's phone number (country + area + number). Returns the variables object with the ticket info.",
						byId: "Same as lookup by number, but using the ticket's internal ID.",
						users: "Lists the company's users/agents (id, name, email). Useful to assign tickets to an agent.",
						tags: "Lists available tags (id, name). Useful to know which tagId to assign.",
						assignTag: "Assigns a tag to an existing ticket.",
						updateTicket: "Updates a ticket: change its status, assigned agent and/or queue.",
						tagIdValue: "ID of the tag to assign (see GET /tags)",
						statusValue: "Ticket status: open, pending or closed",
						userIdValue: "ID of the agent to assign (see GET /users)",
						queueIdValue: "ID of the queue/department",
						typebotTitle: "Typebot / N8N compatibility (POST alternative)",
						typebotDesc: "Platforms that only allow POST (like Typebot) can query/create the ticket by sending data via body or query params. The response includes the variables object ready to map into your flow variables.",
						typebotNumber: "Contact number (or use ?number={{telefono}} in the URL)",
						typebotAtendimento: "Alternatively, the ticket ID (atendimento)",
						typebotNote: "In Typebot: in the HTTP Request block use POST to /ticket?number={{telefono}}, header Authorization: Bearer <TOKEN>, and save the response into variables (data.variables.numero, nome, atendimento).",
						variablesDesc: "Every ticket response includes this variables object, ready to map into your flow:",
					},
					title: "5. External API — N8N / TypeBot",
					intro:
						"Endpoints for external integrations (N8N, TypeBot, etc.). Use the same WhatsApp token as the messaging API. Responses include a variables object compatible with TypeBot/N8N.",
					baseUrl: "Base URL:",
					headersLine: "Headers:",
					getTicketByNumber: "GET — Ticket by number",
					getTicketById: "GET — Ticket by ID",
					getUsers: "GET — Users / agents",
					getTags: "GET — Tags",
					putAssignTag: "PUT — Assign tag",
					putUpdateTicket: "PUT — Update ticket",
					bodyLabel: "Body:",
					altPostTitle: "POST alternatives (body or query for Typebot):",
					postTicketBody1:
						'POST {{base}}/ticket — Body: { "atendimento": 1223 } or { "number": "51980795334" }',
					postTicketBody2:
						"POST {{base}}/ticket?number={{telefono}} — URL variables (Typebot)",
					postTicketBody3:
						"POST {{base}}/ticket/tag?atendimento={{atendimento}}&tagId=6 — query params",
					postTicketBody4:
						'POST {{base}}/ticket — Body: { "atendimento": 1223, "status": "open", "userId": 1 } (update)',
					postUsersTags: "POST {{base}}/users — POST {{base}}/tags",
					variablesObjectTitle: "variables object (ticket responses):",
					variablesList:
						"atendimento, nome, numero, status, canal, grupo, user, userEmail, queue, tags, whatsappNumber, whatsappName",
					typebotGuideTitle: "Typebot guide (validated flow):",
					typebotStep1:
						"Input: ask for number, save in variable telefono",
					typebotStep2:
						"HTTP Request: POST /ticket?number={{telefono}} (use braces to insert variable)",
					typebotStep3: "Headers: Authorization = Bearer token",
					typebotStep4:
						"Save in variables: data.variables.numero, nome, atendimento",
					typebotStep5: "Text: show numero, nome, atendimento",
					seeGuide: "See guide 0275 for full detail.",
				},
				messages: {
					success: "Message sent successfully",
					successMedia: "Media message sent successfully",
					successGroup: "Message sent to the group successfully",
					successGroupMedia:
						"Media message sent to the group successfully",
					groupSendError: "Could not send message to group",
					groupMediaError: "Could not send media to group",
					noPermission:
						"This company cannot access this page. Redirecting…",
				},
				errors: {
					backendUrlNotConfigured: "REACT_APP_BACKEND_URL is not configured",
				},
			},
			flowbuilders: {
				title: "Automated Flows",
				searchPlaceholder: "Search flows...",
				noFlows: "No flows created",
				rowsPerPage: "Rows per page",
				buttons: {
					add: "New Flow",
				},
				table: {
					name: "Name",
					status: "Status",
					createdAt: "Created",
					actions: "Actions",
				},
				status: {
					active: "Active",
					inactive: "Inactive",
				},
				actions: {
					edit: "Edit",
					delete: "Delete",
				},
				confirmationModal: {
					deleteTitle: "Delete Flow",
					deleteMessage:
						"Are you sure you want to delete this flow? This action cannot be undone.",
				},
				toasts: {
					deleted: "Flow deleted successfully",
					created: "Flow created successfully",
					updated: "Flow updated successfully",
					saved: "Flow saved successfully",
					saveSuccess: "Flow saved successfully",
					saveError: "Error saving the flow",
				},
				loading: "Loading flow...",
				editor: {
					nodesPanel: "Available Nodes",
					newFlow: "New Flow",
					saving: "Saving",
					save: "Save",
					cancel: "Cancel",
					canvas: "Flow Canvas",
					noNodes:
						"No nodes in the flow. Click a node in the side panel to add it.",
					connecting: "Connecting... (Click another node)",
					connectionHint:
						"Shift + Click a node to start a connection, then click another node to connect",
					nodesHint: "Click a node to add it to the canvas",
					shortcuts: "Keyboard shortcuts",
					shortcutDrag: "Drag: Click and drag to move",
					shortcutConnect:
						"Connect: Shift + Click the source node, then click the target node",
					shortcutConfig: "Configure: Click the node or double click",
				},
				modals: {
					title: "Configure {nodeType}",
					cancel: "Cancel",
					save: "Save",
					noConfig: "This node requires no configuration",
					message: {
						text: "Message text",
					},
					condition: {
						variable: "Variable",
						operator: "Operator",
						value: "Value",
					},
					start: {
						description:
							"The start node is the entry point of the flow. It requires no additional configuration.",
					},
				},
				simulator: {
					title: "Preview bot",
					restart: "Restart",
					banner:
						"Simulation: no real message is sent and no ticket is modified.",
					canvasLocked: "The workspace is locked during the preview",
					empty: "Press Preview to walk through the flow step by step.",
					running: "Walking through the flow…",
					hsmBadge: "WABA template",
					chooseOption:
						"Pick an option to continue. In real conversations the customer makes this choice.",
					typeReply: "Type the customer's reply to continue.",
					replyPlaceholder: "Customer's reply…",
					freeTextPlaceholder: "…or type any reply (e.g. 9)",
					noOptions:
						"This node has no options configured: the flow would get stuck here.",
					connectionTitle: "Connection",
					connectionHint:
						"Channel warnings depend on the connection: some nodes are not supported by every provider.",
					connectionAuto: "Automatic (first compatible)",
					contactTitle: "Simulated contact",
					// No double braces on purpose: i18next would treat them as interpolation.
					contactHint:
						"Feeds the contact's name, first name and number variables — and with them the outcome of condition nodes.",
					contactName: "Name",
					contactNumber: "Number",
					executeHttp: "Actually run HTTP requests",
					executeAi: "Actually run AI nodes (consumes tokens)",
					variablesTitle: "Flow variables",
					status: {
						waiting: "Waiting for reply",
						completed: "Flow completed",
						error: "Error",
						running: "Running",
					},
					errors: {
						generic: "The preview could not be run",
					},
				},
				validation: {
					noStartNode: "The flow must have at least one start node",
					nameRequired: "The flow name is required",
					panelTitle: "Flow validation",
					allGood: "No issues found in this flow",
					errorsLabel: "{{count}} error(s)",
					warningsLabel: "{{count}} warning(s)",
					blockedPreview: "Fix the errors before previewing the flow",
					goToNode: "Go to node",
					codes: {
						EMPTY_FLOW: "The flow has no nodes",
						NO_START_NODE:
							"The flow has no start node: it will never run",
						MULTIPLE_START_NODES:
							"There are {{count}} start nodes. The engine will pick only one and ignore the rest",
						START_NO_EXIT:
							"The start node has no outgoing connection: the flow ends without doing anything",
						PAUSE_NODE_NO_EXIT:
							"«{{nodeLabel}}» waits for a user reply but has no outgoing connection: the flow will hang",
						CONDITION_MISSING_BRANCH: "Condition «{{nodeLabel}}» has nowhere to go for: {{missing}}. A customer landing there gets no reply. Connect that output or, if the branch is not needed, delete it in the condition",
						BRANCH_NO_EXIT:
							"«{{nodeLabel}}» has {{count}} unconnected output(s) ({{missing}}) and no default connection",
						BRANCH_USES_FALLBACK:
							"«{{nodeLabel}}» has {{count}} unconnected output(s) ({{missing}}): they will use the default connection",
						DEAD_END: "The conversation ends here («{{nodeLabel}}»). If this is the intended ending you can ignore it; to make it explicit, connect it to «Close ticket» or «Transfer to department»",
						ORPHAN_NODE:
							"«{{nodeLabel}}» is unreachable from the start node: it will never run",
						INFINITE_LOOP:
							"Loop with no waiting point ({{length}} nodes): the engine stops at {{maxIterations}} iterations and the flow ends in error",
						EMPTY_TEXT: "«{{nodeLabel}}» has no text configured",
						MISSING_MEDIA: "«{{nodeLabel}}» has no file uploaded",
						MENU_NO_OPTIONS: "Menu «{{nodeLabel}}» has no options",
						BUTTONS_NO_BUTTONS: "«{{nodeLabel}}» has no buttons configured",
						HSM_NO_TEMPLATE: "«{{nodeLabel}}» has no template selected",
						HSM_NO_CONNECTION: "«{{nodeLabel}}» has no WABA connection selected",
						TAG_NO_TAG: "«{{nodeLabel}}» has no tag selected",
						TRANSFER_NO_QUEUE: "«{{nodeLabel}}» has no target queue",
						JUMP_NO_FLOW: "«{{nodeLabel}}» has no target flow selected",
						FILEINPUT_NO_TEXT: "«{{nodeLabel}}» has no request text: the customer would not know what to send",
						JUMP_HAS_EXIT: "«{{nodeLabel}}» has nodes connected after it: they will not run, control moves to the target flow",
						INPUT_NO_EXHAUSTED_EXIT: "«{{nodeLabel}}» has a {{count}}-attempt limit but its «no valid answer» exit is not connected: it will keep asking",
						CLOSE_HAS_EXIT: "«{{nodeLabel}}» has nodes connected after it: they will not run, the ticket is closed",
						SETVAR_NO_KEY: "«{{nodeLabel}}» has no variable name configured",
						HTTP_NO_URL: "«{{nodeLabel}}» has no URL configured",
						CONDITION_NO_VARIABLE: "«{{nodeLabel}}» has no variable to evaluate",
						CONDITION_BRANCH_EMPTY: "«{{nodeLabel}}» has a branch with no comparisons: it will never match",
						CONTENT_NO_ITEMS: "«{{nodeLabel}}» has no elements: it will send nothing",
						CONTENT_ITEMS_EMPTY:
							"«{{nodeLabel}}» has {{count}} of {{total}} element(s) with no content: they will be skipped when sending",
						OPENAI_NO_PROMPT:
							"«{{nodeLabel}}» has no AI Agent selected: it will use the inherited configuration",
						TIMING_ZERO: "«{{nodeLabel}}» has a time of 0: it will do nothing",
						NODE_REQUIRES_WABA:
							"«{{nodeLabel}}» only works in WhatsApp Cloud API (WABA) flows",
						TELEGRAM_BUTTONS_AS_MENU:
							"«{{nodeLabel}}»: on Telegram buttons arrive as a numbered menu (the customer replies «1», «2»…)",
					},
				},
			},
			queues: {
				title: "Queues",
				toasts: {
					deleted: "Queue deleted successfully.",
				},
				table: {
					id: "ID",
					department: "Queue",
					name: "Name",
					color: "Color",
					automation: "Automation",
					greeting: "Greeting message",
					actions: "Actions",
				},
				automationLabels: {
					flowbuilder: "FLOWBUILDER",
					prompt: "PROMPT",
					integration: "INTEGRATION",
					chatbot: "CHATBOT",
					none: "No automation",
				},
				placeholders: {
					noGreeting: "No message",
				},
				tooltips: {
					editQueue: "Edit queue",
					deleteQueue: "Delete queue",
				},
				buttons: {
					add: "Add queue",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
				},
			},
			queueOptions: {
				title: "Menu option chatbot",
				subtitle:
					"Define the buttons the contact will see in the chat (multi-level menu). This is not free-text AI: the user taps options. Use “Add” for each menu item.",
				add: "Add",
				placeholder: {
					title: "Option title",
					message: "Option text",
				},
				undefinedTitle: "Untitled",
			},
			queueSelect: {
				inputLabel: "Queues",
			},
			users: {
				title: "Users",
				table: {
					id: "ID",
					status: "Status",
					name: "Name",
					email: "Email",
					profile: "Profile",
					department: "Department",
					connection: "Connection",
connectionFromTeam: "from their team",
										connectionNone: "No connection",
										lastConnection: "Last connection",
					lastConnectionNow: "Online now",
					connected: "Connected",
					disconnected: "Disconnected",
					actions: "Actions",
				},
				buttons: {
					add: "Add user",
				},
				toasts: {
					deleted: "User deleted sucessfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"All user data will be lost. Users' open tickets will be moved to queue.",
				},
			},
			settings: {
				success: "Settings saved successfully.",
				error: "Could not save settings.",
				title: "Settings",
				schedules: {
					success: "Schedules saved successfully.",
				},
				settings: {
					userCreation: {
						name: "User creation",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
				},
				tabs: {
					options: "Options",
					schedules: "Schedules",
					version: "Versions",
					alerts: "Alerts",
					subscriptions: "Subscriptions",
					logo: "Web",
					companies: "Companies",
					registerCompany: "Register company",
					plans: "Plans",
					help: "Help",
					performance: "Server performance",
				},
				options: {
					userRating: "User rating",
					userRatingDesc: "Allows users to rate the service received",
					userRatingMessageText: "Rating request message",
					userRatingMessageTextDesc:
						"Sent when the ticket is closed (along with the WhatsApp connection text if any). Max. 500 characters. Same rules as the call message: cannot be empty when saving.",
					userRatingMessageTextPlaceholder: "Type 1 to 3 to rate…",
					sendGreetingAcceptedMessageText: "Greeting text on accept (menu)",
					sendGreetingAcceptedMessageTextDesc:
						"Used as the options menu greeting when the queue has no custom message. Mustache variables: {{name}}, {{firstName}}, etc.",
					sendGreetingAcceptedMessageTextPlaceholder: "Hi {{name}}! Thanks for contacting us…",
					transferTicketMessageText: "Transfer between queues message",
					transferTicketMessageTextDesc:
						"Only sent if “Send transfer message” is enabled. Variables: {{name}}, {{firstName}} and {queueName} or {{queueName}} for the target queue.",
					transferTicketMessageTextPlaceholder: "Hi {{name}}! You have been transferred…",
					greetingOneQueueMessageText: "Greeting with a single queue",
					greetingOneQueueMessageTextDesc:
						"Replaces or complements the connection greeting when only one queue exists and the option is on. Mustache: {{name}}, {{firstName}}, etc. If left blank when saving, default text is restored.",
					greetingOneQueueMessageTextPlaceholder: "Hi {{name}}! Thanks for writing us…",
					scheduleType: "Schedule type",
					ignoreGroupMessages: "Ignore group messages",
					acceptCall: "Accept calls",
					sendCallAutoMessage: "Send automatic message when calls are disabled",
					sendCallAutoMessageDesc: "When enabled, an automatic message is sent when calls are disabled",
					callAutoMessage: "Automatic call message",
					callAutoMessageDesc: "Customize the message sent automatically when calls are disabled",
					callAutoMessagePlaceholder: "Type the automatic message (max 500 characters)",
					restoreDefault: "Restore default",
					preview: "Preview",
					chatbotType: "Chatbot type",
					sendGreetingAccepted: "Send greeting on accept",
					sendGreetingAcceptedDesc: "Sends automatic greeting when a ticket is accepted",
					sendTransferMessage: "Send transfer message",
					sendTransferMessageDesc: "Sends a message when transferring between queues",
					teamsEnabled: "Work with subgroups",
					teamsEnabledDesc: "Enables work teams: the Subgroups page appears and each supervisor also sees their team queue. When off, each user is configured individually.",
					teamsEnabledSaved: "Working mode updated",
					teamsEnabledError: "Could not change the working mode",
										removeTagsOnCloseTicket: "Remove tags on close",
					removeTagsOnCloseTicketDesc:
						"If enabled, closing a ticket removes all its tags and a confirmation is asked before closing",
					reopenTicketToBot: "Return to bot on reopen",
					reopenTicketToBotDesc:
						"If enabled, when the contact writes to a closed ticket it goes back to the connection's default department and its bot, with no agent (once the configured waiting minutes have passed). If disabled, it keeps its previous department",
					reopenTicketToBotMinutes: "Waiting minutes before returning to the bot",
					reopenTicketToBotMinutesDesc:
						"If the contact writes again before these minutes have passed since closing, the ticket goes back to the same department so an agent can continue. After that, the bot takes it. Use {minutos} in the close message to show this value. This is not the connection's “Transfer by time”.",
					reopenTicketToBotMinutesLabel: "Minutes",
					reopenTicketToBotMinutesHelper: "0 = the bot answers right away (max 1440)",
					reopenTicketToBotMinutesError: "Could not save the waiting minutes",
					reopenGraceMessage: "Notice when writing again within the wait",
					reopenGraceMessageDesc:
						"Sent once to a contact who writes before the waiting minutes are over, so they know an agent will help them. If nobody does and they write again after that time, the bot takes over. Variables: {departamento}, {minutos}, {nroticket}. Leave empty to send no notice.",
					reopenGraceMessageError: "Could not save the notice",
					sendTicketCloseMessage: "Message when closing ticket",
					sendTicketCloseMessageDesc:
						"Sends a WhatsApp message when the ticket is closed (not for groups). Use {nroticket} for the ticket number and {minutos} for the waiting minutes before returning to the bot",
					ticketCloseMessageText: "Close message text",
					ticketCloseMessageTextDesc:
						"Same rules as the automatic call message: required text (max 500 characters), editable with “Restore default”. Variables: {nroticket} = ticket ID; {minutos} = waiting minutes before returning to the bot. Sent after confirmed close.",
					ticketCloseMessageTextPlaceholder:
						"💬⚙️ *Support ticket:* {nroticket} was closed. If you need anything else in the next {minutos} minutes, we'll keep helping you; after that, our assistant 🤖 will help you.",
					sendGreetingOneQueue: "Send greeting with one queue",
					sendGreetingOneQueueDesc: "Shows greeting when only one queue is available",
					globalSettings: "Global settings",
					registrationAllowed: "Registration allowed",
					registrationVisible: "Registration visible",
					trialTime: "Trial period",
					mainSettings: "Main settings",
					messagingSettings: "Messaging settings",
					customerMessageLocale: "Automatic message language for WhatsApp contacts",
					customerMessageLocaleDesc:
						"Language for greetings, transfers, templates, and automatic texts sent to the contact on WhatsApp. Independent from each operator's panel language.",
					scheduleTypeDesc: "Defines the type of business hours",
					ignoreGroupMessagesDesc: "Ignores WhatsApp group messages",
					chatbotTypeDesc: "Chatbot type for automatic replies",
					internalSignature: "Internal signatures",
					internalSignatureDesc: "Automatically shows the user name on each message (internal only)",
					validateWhatsAppNumbers: "Validate WhatsApp numbers",
					validateWhatsAppNumbersDesc:
						"Validates numbers on WhatsApp when importing contact lists. If disabled, all numbers are processed without validation.",
					timezoneForCampaigns: "Timezone for campaigns",
					timezoneForCampaignsDesc: "Select your timezone for mass campaigns",
					timezone: "Timezone",
					callAutoMessageMaxLength: "Message cannot exceed 500 characters",
					callAutoMessageSaveError: "Error saving message",
					characters: "characters",
					registrationAllowedDesc: "Allows registration of new users",
					registrationVisibleDesc: "Shows the registration form publicly",
					trialTimeDesc: "Trial days for new users",
					day: "day",
					days: "days",
					additionalSettings: "Additional settings",
					webInfo: "Web info",
					websiteTitle: "Website title",
					websiteTitleDesc: "Title shown in the browser tab and search results",
					websiteDescription: "Website description",
					websiteDescriptionDesc: "Description shown in search and social previews",
					websiteKeyword: "Website keyword",
					websiteKeywordDesc: "Main SEO keywords",
					companyName: "Company name",
					companyNameDesc: "Company name on login copyright",
					companyNameCopyright: "Company name (copyright)",
					logos: "Logos",
					exampleCliqueaCRM: "Example: Cliquea CRM",
					exampleAutomatiza: "Example: Automate, connect and sell more!",
					exampleWhatsAppAPI: "Example: WHATSAPP API",
					exampleWatoolx: "Example: watoolx.com",
					localeEs: "Spanish",
					localeEn: "English",
					localePt: "Portuguese",
					loadingTimezones: "Loading timezones…",
					timezoneQuickPeru: "Peru (America/Lima)",
					timezoneQuickColombia: "Colombia (America/Bogota)",
					ariaSectionMain: "Main settings",
					ariaSectionMessaging: "Messaging settings",
				},
				states: {
					disabled: "Disabled",
					enabled: "Enabled",
					activated: "On",
					deactivated: "Off",
					accept: "Accept",
					notAccept: "Do not accept",
					text: "Text",
					updating: "Updating...",
					yes: "Yes",
					no: "No",
					queue: "Queue",
					company: "Company",
				},
				versionPage: {
					loading: "Loading version information…",
					title: "System version information",
					ariaVersion: "Version",
					currentVersion: "Current version",
					changelogChip: "changelog {{version}}",
					releaseDateChangelog: "Release date (CHANGELOG):",
					changeType: "Change type",
					milestoneTitle: "Architectural milestone",
					milestoneDefault: "Evolution from monolith to modular hexagonal architecture and full technical-debt paydown. Foundation for Meta Cloud API and new channels.",
					gitDateChip: "Date via Git",
					releaseSummary: "Latest release summary",
					viewFullHistory: "View full history →",
					changesCount: "{{count}} changes",
					frontendVersion: "Frontend version",
					apiVersion: "API version (backend package)",
					baseWhaticket: "Base Whaticket:",
					lastUpdate: "Last update",
					semanticFooter: "Semantic versioning in use",
					fullHistory: "View full history →",
					na: "N/A",
				},
				subscriptionsPayment: {
					title: "Payment methods",
					intro:
						"Configure PayPal and Stripe credentials to enable recurring payments. ",
					introNote:
						"Note: After saving, restart the backend server for changes to apply.",
					saving: "Saving…",
					sectionPaypal: "PayPal",
					sectionStripe: "Stripe",
					sectionCurrency: "Currency",
					paypalClientIdLabel: "PayPal client ID",
					paypalClientIdDesc: "Client ID of your PayPal application",
					paypalClientIdField: "PayPal Client ID",
					paypalClientIdHelper:
						"Example: AQkquBDf1zctJOWLbrloE4zQnlX4rQvBfhXUZHX96zShVqSB2ikbkGg",
					paypalSecretLabel: "PayPal client secret",
					paypalSecretDesc: "Secret of your PayPal application",
					paypalSecretField: "PayPal Client Secret",
					paypalSecretHelper: "Your PayPal application secret",
					paypalModeLabel: "PayPal mode",
					paypalModeDesc: "Sandbox (testing) or live (production)",
					modeField: "Mode",
					modeSandbox: "Sandbox (testing)",
					modeLive: "Live (production)",
					stripeKeyLabel: "Stripe secret key",
					stripeKeyDesc: "Secret key from your Stripe account (sk_test_… or sk_live_…)",
					stripeKeyField: "Stripe Secret Key",
					stripeKeyHelper: "Example: sk_test_51AbCdEf…",
					stripeWebhookLabel: "Stripe webhook secret",
					stripeWebhookDesc: "Webhook secret to verify events (whsec_…)",
					stripeWebhookField: "Stripe Webhook Secret",
					stripeWebhookHelper: "Example: whsec_1234567890abcdef",
					currencyLabel: "Preferred currency",
					currencyDesc: "Currency shown on plans and invoices",
					currencyField: "Currency",
					currencyUSD: "USD — US dollar ($)",
					currencyEUR: "EUR — Euro (€)",
					currencyGBP: "GBP — Pound sterling (£)",
					currencyBRL: "BRL — Brazilian real (R$)",
					currencyMXN: "MXN — Mexican peso ($)",
					currencyARS: "ARS — Argentine peso ($)",
					currencyCLP: "CLP — Chilean peso ($)",
					currencyCOP: "COP — Colombian peso ($)",
					currencyPEN: "PEN — Peruvian sol (S/)",
					toastPaypalId: "PayPal Client ID saved",
					toastPaypalSecret: "PayPal Client Secret saved",
					toastPaypalMode: "PayPal mode updated",
					toastStripeKey: "Stripe Secret Key saved",
					toastStripeWebhook: "Stripe Webhook Secret saved",
					toastCurrency: "Currency updated",
				},
				vpsAlerts: {
					validation: {
						emailConnectionSelect: "Email connection: choose which one sends the alerts in «Email connection *».",
						adminEmailRequired:
							"Admin email: required when using email.",
						adminEmailInvalid: "Admin email: invalid format.",
						whatsappSelect:
							"WhatsApp: pick a line in “WhatsApp connection *” (empty blocks save and nothing is sent).",
						adminWhatsappRequired:
							"Admin WhatsApp number: required when using WhatsApp.",
						adminWhatsappInvalid:
							"WhatsApp number: use 10–15 digits; you may prefix +.",
						whatsappTemplateRequired: "WhatsApp message template cannot be empty.",
					},
					validationModal: {
						bodyIntro: "The request was not sent. Complete the following:",
						titleTest: "Missing data for the test",
						titleSave: "Cannot save: incomplete form",
					},
					notes: {
						noEmailConnection: "Note: there is no email connection. Create one in Connections → Add → Email.",
						noConnectedWhatsapp:
							"Note: no WhatsApp in CONNECTED status; check “Connections”.",
					},
					test: {
						lineEmailOk: "✅ Email sent successfully",
						lineWhatsappOk: "✅ WhatsApp sent successfully",
						successIntro: "Test notification sent successfully:",
						footerEmail: "Check your email to confirm receipt.",
						footerWhatsapp: "Check your WhatsApp to confirm receipt.",
						footerBoth: "Check your email and WhatsApp to confirm receipt.",
						errorIntro: "Error sending test notification:",
						unknownError: "Unknown error",
					},
					save: {
						notSavedTitle: "Configuration was not saved",
						notSavedBody:
							"Check any error message on screen and your connection. If it persists, try again in a few seconds.",
						successTitle: "✅ Configuration saved",
						successBody: "VPS notification settings were saved successfully.",
						errorTitle: "❌ Save error",
						errorBody: "Error saving configuration: {{message}}",
					},
					loadError:
						"Could not load VPS alert configuration: {{error}}. Ensure your user is admin, the API is available, and DB objects exist (VPSNotificationConfig, SP).",
					retry: "Retry",
					generalSection: "General enablement",
					toggleLabel: "Enable alert system and automatic cleanup",
					infoWhyTitle: "Why enable this system?",
					infoIntro:
						"This alert and automatic cleanup system is especially useful if:",
					infoLi1: "Your business handles thousands of WhatsApp messages daily",
					infoLi2: "You generate many database records",
					infoLi3: "You need proactive server monitoring",
					infoLi4: "You want to prevent full-disk issues",
					infoClosing:
						"Recommended to keep it enabled: binary log cleanup prevents the disk from filling up even without notifications.",
					warningEnabled:
						"IMPORTANT: notifications are optional. With no channel («None»), the system applies thresholds and cleanup silently; choose Email or WhatsApp only if you want to be alerted.",
					notificationsSection: "Notification settings",
					channelEmail: "Email",
					channelWhatsapp: "WhatsApp",
					channelBoth: "Both",
					channelNone: "None (thresholds and cleanup only)",
					emailSection: "Email settings",
					emailConnectionLabel: "Email connection *",
					emailConnectionHint: "Alerts and password recovery are sent through this connection. Applied as soon as you choose it.",
					noEmailConnection: "There is no email connection. Create one in Connections → Add → Email to receive alerts by email.",
					goToConnections: "Go to Connections",
					selectEmailConnection: "Choose a connection…",
					emailTemplateOptional: "Email template (optional)",
					useDefaultTemplates: "Use default templates",
					adminEmailLabel: "Admin email *",
					invalidEmail: "Invalid email format",
					adminEmailHint: "Email where you will receive alerts",
					whatsappSection: "WhatsApp settings",
					whatsappConnectionLabel: "WhatsApp connection *",
					selectWhatsapp: "Select WhatsApp…",
					whatsappTemplateLabel: "WhatsApp message template",
					whatsappTemplateVars:
						"Available variables: {alertType}, {diskUsage}, {binaryLogsSize}, {cpuUsage}, {memoryUsage}, {message}, {subject}",
					adminWhatsappLabel: "Admin WhatsApp number *",
					invalidWhatsapp: "Invalid format (10–15 digits, optional +)",
					adminWhatsappHint: "Number where you will receive alerts (with country code)",
					thresholdsSection: "Alert thresholds",
					diskPct: "Disk (%)",
					diskHelp: "Alert when disk use exceeds this percentage",
					binaryGb: "Binary logs (GB)",
					binaryHelp: "Alert when binary log size exceeds this value",
					cpuPct: "CPU (%)",
					cpuHelp: "Alert when CPU use exceeds this percentage",
					memPct: "Memory (%)",
					memHelp: "Alert when memory use exceeds this percentage",
					enableDisk: "Enable disk alerts",
					enableBinary: "Enable binary log alerts",
					enableCpu: "Enable CPU alerts",
					enableMem: "Enable memory alerts",
					enableCritical: "Enable critical alerts",
					frequencySection: "Notification frequency and automatic cleanup",
					alertFreqLabel: "Alert frequency (hours)",
					alertFreqHelp: "How often automatic alerts are sent (1–48 hours)",
					cleanupSubtitle: "Automatic server cleanup",
					cleanupInfoTitle: "What this section does",
					cleanupInfoIntro:
						"With cleanup enabled, the system can run maintenance without manual steps:",
					cleanupInfoLi1:
						"If disk exceeds the threshold (%): full routine (binary log purge per server policy, iterative steps, critical table optimization when needed).",
					cleanupInfoLi2:
						"If disk is below threshold but MySQL binary logs exceed the GB threshold: progressive log purge (conservative then more aggressive), typical when total disk is large but binlogs grow fast.",
					cleanupRisk:
						"Operational risk: binary log purge affects point-in-time recovery (PITR). Use thresholds aligned with your backup and MySQL replication policy.",
					enableAutoCleanup: "Enable automatic cleanup",
					enableDiskAutoCleanup: "Include disk cleanup (optimizes tables)",
					diskCleanupHelp: "When the disk threshold is exceeded it purges binary logs and runs OPTIMIZE TABLE until usage drops. It can lock large tables for minutes: enable it only if you need it.",
					cleanupCooldownNote:
						"Alert frequency ({{hours}} h) also limits how often cleanup triggered only by binary logs (GB) can repeat (cooldown since last run of that type).",
					cleanupDiskThreshold: "Disk threshold for cleanup (%)",
					cleanupDiskHelp:
						"When disk use reaches this %, the full cleanup routine runs (binlogs + extra DB steps as applicable).",
					cleanupBinlogGb: "Binary log threshold for cleanup (GB)",
					cleanupBinlogHelp:
						"If estimated binary log size ≥ this value and disk did not trigger the previous routine, logs are purged progressively. Often lower than alert-only threshold (GB).",
					lastCleanup: "Last automatic cleanup (binary log threshold): {{date}}",
					saveConfig: "Save configuration",
					saving: "Saving…",
					sendTest: "Send test notification",
					sending: "Sending…",
					testModal: {
						sending: "Sending test notification…",
						success: "✅ Notification sent",
						error: "❌ Send error",
						pleaseWait: "Please wait while the notification is sent…",
						tipPrefix: "Tip:",
						tipEmail: "Check your email to confirm receipt.",
						tipWhatsapp: "Check your WhatsApp to confirm receipt.",
						tipBoth: "Check your email and WhatsApp to confirm receipt.",
						close: "Close",
						cancel: "Cancel",
					},
					accept: "OK",
					defaultWhatsAppTemplate:
						"⚠️ VPS ALERT: {alertType}\n📊 System status:\n💾 Disk: {diskUsage}%\n📝 Binary logs: {binaryLogsSize} GB\n⚡ CPU: {cpuUsage}%\n🧠 Memory: {memoryUsage}%\n\n{message}",
				},
			},
			messagesList: {
				deletedByContact: "This message was deleted by the contact",
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Return",
						resolve: "Resolve",
						reopen: "Reopen",
						accept: "Accept",
					},
				},
			},
			messagesInput: {
				placeholderOpen: "Type a message",
				placeholderClosed: "Reopen or accept this ticket to send a message.",
				signMessage: "Sign",
				mediaCaptionPlaceholder:
					"Add a caption… (optional — sent with the file)",
			},
			contactDrawer: {
				header: "Contact details",
				buttons: {
					edit: "Edit contact",
				},
				extraInfo: "Other information",
			},
			ticketOptionsMenu: {
				schedule: "Schedule",
				openInNewWindow: "Open chat in new tab",
				openInNewUnavailable:
					"This ticket has no UUID and cannot be opened in a new tab.",
				delete: "Delete",
				transfer: "Transfer",
				confirmationModal: {
					title: "Delete ticket #",
					titleFrom: "from contact ",
					message: "Attention! All ticket's related messages will be lost.",
				},
				buttons: {
					delete: "Delete",
					cancel: "Cancel",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancel",
				},
			},
			messageOptionsMenu: {
				delete: "Delete",
				reply: "Reply",
				confirmationModal: {
					title: "Delete message?",
					message: "This action cannot be reverted.",
				},
			},
			backendErrors: {
				ERR_CAMPAIGN_EMAIL_NOT_SUPPORTED: "Campaigns cannot be sent through an email connection. Choose a WhatsApp connection.",
				ERR_EMAIL_NOT_SUPPORTED: "This action does not exist for email.",
				ERR_EMAIL_AUTH_FAILED: "Gmail rejected the address or the app password.",
				ERR_EMAIL_SEND_FAILED: "The email could not be sent. Please try again.",
				ERR_EMAIL_COMPOSE_INVALID_CC: "Check the «CC» addresses: one is not valid (20 at most).",
				ERR_EMAIL_COMPOSE_INVALID_BCC: "Check the «BCC» addresses: one is not valid (20 at most).",
				ERR_EMAIL_COMPOSE_INVALID_TO: "Enter a valid email address in «To».",
				ERR_EMAIL_COMPOSE_SUBJECT_REQUIRED: "Enter the email subject.",
				ERR_EMAIL_COMPOSE_SUBJECT_TOO_LONG: "The subject cannot exceed 200 characters.",
				ERR_EMAIL_COMPOSE_BODY_REQUIRED: "Enter the email message.",
				ERR_EMAIL_COMPOSE_CONNECTION_REQUIRED: "Choose the email connection to send from.",
				ERR_EMAIL_COMPOSE_NOT_EMAIL: "The selected connection is not an email connection.",
				ERR_EMAIL_COMPOSE_QUEUE_NOT_FOUND: "The selected department does not exist.",
				ERR_EMAIL_INVALID_ADDRESS: "The email address is not valid.",
				ERR_EMAIL_ACCOUNT_NOT_FOUND: "That email connection was not found.",
				ERR_EMAIL_NOT_SUPER: "Only the super administrator can choose the system mailbox.",
				ERR_EMAIL_NO_SYSTEM_MAILBOX: "No email connection sends the system emails. Choose one in Settings → Alerts.",
				ERR_EMAIL_TEMPLATE_NOT_FOUND: "That template was not found.",
				ERR_EMAIL_TEMPLATE_SUBJECT_REQUIRED: "The template needs a subject.",
				ERR_EMAIL_TEMPLATE_BODY_REQUIRED: "The template needs HTML content.",
				ERR_SYNC_POLICY_INVALID_MODE: "Invalid history mode.",
				ERR_SYNC_POLICY_INVALID_DAYS: "History can only be 7, 15 or 30 days.",
				ERR_SYNC_POLICY_INVALID_MAX: "The per-chat message limit must be between 1 and 1000.",
				ERR_SYNC_POLICY_NOT_BAILEYS: "History is only configurable on Baileys API connections.",
				ERR_SYNC_POLICY_CONNECTION_NOT_FOUND: "Connection not found.",
				ERR_TELEGRAM_CHANNEL_DISABLED: "The Telegram channel is not enabled on this platform.",
				ERR_TELEGRAM_INVALID_TOKEN: "The bot token is invalid or was revoked. Copy it again from @BotFather.",
				ERR_TELEGRAM_API_UNREACHABLE: "Telegram could not be reached. Try again in a few minutes.",
				ERR_TELEGRAM_WEBHOOK_REJECTED: "Telegram rejected the server address. The backend needs a public HTTPS URL.",
				ERR_TELEGRAM_ACCOUNT_IN_USE: "That Telegram account is already used by another connection.",
				ERR_TELEGRAM_RESPONSIBILITY_NOT_ACCEPTED: "You must accept the responsibility notice to connect your personal account.",
				ERR_TELEGRAM_NOT_CONFIGURED: "Telegram access is not configured on this platform yet. Contact your administrator.",
				ERR_TELEGRAM_NOT_USER_CONNECTION: "This connection is not a personal Telegram account.",
				ERR_TELEGRAM_NOT_WAITING_PASSWORD: "Telegram is not waiting for the password right now. Generate a new QR.",
				ERR_TELEGRAM_NAME_REQUIRED: "Enter a name for the connection.",
				ERR_TELEGRAM_PASSWORD_REQUIRED: "Enter your two-step verification password.",
				ERR_TELEGRAM_BOT_IN_USE: "That bot is already used by another connection. A Telegram bot can only be in one.",
				ERR_TELEGRAM_TOKEN_IN_USE: "That token is already used by another connection.",
				ERR_TELEGRAM_BOT_NOT_FOUND: "This connection has no Telegram bot configured.",
				ERR_TELEGRAM_CHAT_NOT_REACHABLE: "This contact cannot be reached on Telegram: they never started the bot or blocked it.",
				ERR_CAMPAIGN_TELEGRAM_NOT_SUPPORTED: "Campaigns are not available for Telegram connections.",
				ERR_TRANSFER_SIN_DESTINO: "Choose a department or a person: the ticket cannot be left without a destination.",
				ERR_TRANSFER_FUERA_DE_EQUIPO: "That person belongs to another team. You can route the ticket to their department, or ask your supervisor to move it.",
				ERR_NO_OTHER_WHATSAPP:
					"There must be at lest one default WhatsApp connection.",
				ERR_NO_DEF_WAPP_FOUND:
					"No default WhatsApp found. Check connections page.",
				ERR_WAPP_DUP_NAME: "That name is already being used by another connection.",
				ERR_WAPP_NOT_INITIALIZED:
					"This WhatsApp session is not initialized. Check connections page.",
				ERR_WAPP_CHECK_CONTACT:
					"Could not check WhatsApp contact. Check connections page.",
				ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Could not download media from WhatsApp. Check connections page.",
				ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
				ERR_SENDING_WAPP_MSG:
					"Error sending WhatsApp message. Check connections page.",
				ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
				ERR_OTHER_OPEN_TICKET:
					"There's already an open ticket for this contact.",
				ERR_SESSION_EXPIRED: "Session expired. Please login.",
				ERR_TOO_MANY_ATTEMPTS: "Too many attempts. Please wait a few minutes and try again.",
				ERR_RESET_EMAIL_REQUIRED: "Enter your email.",
				ERR_RESET_TOKEN_INVALID: "The link is not valid. Request a new one.",
				ERR_RESET_TOKEN_EXPIRED: "The link expired. Request a new one.",
				ERR_RESET_TOKEN_USED: "This link was already used. Request a new one.",
				ERR_RESET_PASSWORD_TOO_SHORT: "The password must have at least 8 characters.",
				ERR_RESET_PASSWORD_TOO_LONG: "The password is too long (128 characters max).",
				ERR_TOO_MANY_REQUESTS: "The panel is making too many requests with your user. Wait a few seconds and try again. If your account is open in several tabs or computers, close the ones you are not using.",
				ERR_PAYLOAD_TOO_LARGE: "The data sent is too large.",
				ERR_USER_CREATION_DISABLED:
					"User creation was disabled by administrator.",
				ERR_NO_PERMISSION: "You don't have permission to access this resource.",
				ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
				ERR_NO_SETTING_FOUND: "No setting found with this ID.",
				ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
				ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
				ERR_NO_USER_FOUND: "No user found with this ID.",
				ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
				ERR_CREATING_MESSAGE: "Error while creating message on database.",
				ERR_CREATING_TICKET: "Error while creating ticket on database.",
				ERR_FETCH_WAPP_MSG:
					"Error fetching the message in WhtasApp, maybe it is too old.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"This color is already in use, pick another one.",
				ERR_QUEUE_NAME_ALREADY_EXISTS:
					"This department name already exists, choose another one.",
				ERR_WAPP_GREETING_REQUIRED:
					"Greeting message is required if there is more than one queue.",
				ERR_INTERNAL_SERVER: "Internal server error. Try again or contact support.",
				ERR_DB_VALIDATION: "The data did not pass database validation rules.",
				ERR_TICKET_UPDATE_FAILED: "Could not update the ticket. Please try again.",
				ERR_SETTING_FOREIGN_COMPANY: "You cannot change another company's settings.",
				ERR_NO_WBOT_FOR_WHATSAPP:
					"No active WhatsApp session for connection {{whatsappId}}. Check the connections page.",
				ERR_UNKNOWN: "An unexpected error occurred.",
			},
			presence: {
				composing: "Typing...",
				recording: "Recording audio...",
			},
			languages: {
				"pt-BR": "Português",
				en: "English",
				es: "Español",
			},
		},
	},
};

export { messages };
